import { forwardRef, SVGAttributes } from 'react';

export type IconType =
  | 'base'
  | 'menu'
  | 'chevronLeft'
  | 'chevronRight'
  | 'chevronUp'
  | 'chevronDown'
  | 'helpCircled'
  | 'infoCircled'
  | 'plus'
  | 'australia'
  | 'close'
  | 'warning'
  | 'check'
  | 'retry'
  | 'search'
  | 'notifications'
  | 'moreHorizontal'
  | 'moreVertical'
  | 'upgrade'
  | 'error'
  | 'emailOutline'
  | 'pending'
  | 'protection'
  | 'externalLink'
  | 'share'
  | 'attach'
  | 'download'
  | 'upload'
  | 'checkboxFill'
  | 'checkboxEmpty'
  | 'sadFace'
  | 'satisfiedFace'
  | 'happyFace'
  | 'sort'
  | 'delete'
  | 'edit'
  | 'location'
  | 'faq'
  | 'like'
  | 'dislike'
  | 'filter'
  | 'gallery'
  | 'arrowLeft'
  | 'arrowRight'
  | 'arrowDown'
  | 'arrowTop'
  | 'camera'
  | 'minus'
  | 'link'
  | 'copy'
  | 'message'
  | 'photoFile'
  | 'database'
  | 'transfer'
  | 'user'
  | 'add'
  | 'usd'
  | 'equal'
  | 'multiply'
  | 'show'
  | 'hide'
  | 'addFilter'
  | 'overview'
  | 'transactions'
  | 'expand'
  | 'collapse'
  | 'congrats'
  | 'percent'
  | 'transactionLimit'
  | 'lockOpened'
  | 'earth'
  | 'bankTransfer'
  | 'bills'
  | 'gift'
  | 'store'
  | 'calendar'
  | 'lockClosed'
  | 'send'
  | 'people'
  | 'logOut'
  | 'downloadApp'
  | 'shield'
  | 'apiToken'
  | 'addPeople'
  | 'sell'
  | 'bitcoin'
  | 'ethereum'
  | 'loader'
  | 'phone'
  | 'decline'
  | 'usdc'
  | 'usdt'
  | 'dai'
  | 'renbtc'
  | 'wbtc'
  | 'busd'
  | 'gusd'
  | 'giftcard'
  | 'verification';

export const iconNames = [
  'base',
  'menu',
  'chevronLeft',
  'chevronRight',
  'chevronUp',
  'chevronDown',
  'helpCircled',
  'infoCircled',
  'plus',
  'australia',
  'close',
  'warning',
  'check',
  'retry',
  'search',
  'notifications',
  'moreHorizontal',
  'moreVertical',
  'upgrade',
  'error',
  'emailOutline',
  'pending',
  'protection',
  'externalLink',
  'share',
  'attach',
  'download',
  'upload',
  'checkboxFill',
  'checkboxEmpty',
  'sadFace',
  'satisfiedFace',
  'happyFace',
  'sort',
  'delete',
  'edit',
  'location',
  'faq',
  'like',
  'dislike',
  'filter',
  'gallery',
  'arrowLeft',
  'arrowRight',
  'arrowDown',
  'arrowTop',
  'camera',
  'minus',
  'link',
  'copy',
  'message',
  'photoFile',
  'database',
  'transfer',
  'user',
  'add',
  'usd',
  'equal',
  'multiply',
  'show',
  'hide',
  'addFilter',
  'overview',
  'transactions',
  'expand',
  'collapse',
  'congrats',
  'percent',
  'transactionLimit',
  'lockOpened',
  'earth',
  'bankTransfer',
  'bills',
  'gift',
  'store',
  'calendar',
  'lockClosed',
  'send',
  'people',
  'logOut',
  'downloadApp',
  'shield',
  'apiToken',
  'addPeople',
  'sell',
  'bitcoin',
  'ethereum',
  'loader',
  'phone',
  'decline',
  'usdc',
  'usdt',
  'dai',
  'renbtc',
  'wbtc',
  'busd',
  'gusd',
  'giftcard',
  'verification',
];

export interface IconProps extends SVGAttributes<SVGSVGElement> {
  className?: string;
  name: IconType;
  size?: number;
  fill?: string;
  stroke?: string;
}

export const Icon = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  const { className, name, size = '20', fill, stroke } = props;

  switch (name) {
    case 'base':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="6" />
        </svg>
      );
    case 'menu':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M3 18V16.5H21V18H3ZM3 12.75V11.25H21V12.75H3ZM3 7.5V6H21V7.5H3Z" />
        </svg>
      );
    case 'chevronLeft':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M14.71 6.71001C14.32 6.32001 13.69 6.32001 13.3 6.71001L8.70998 11.3C8.31998 11.69 8.31998 12.32 8.70998 12.71L13.3 17.3C13.69 17.69 14.32 17.69 14.71 17.3C15.1 16.91 15.1 16.28 14.71 15.89L10.83 12L14.71 8.12001C15.1 7.73001 15.09 7.09001 14.71 6.71001Z" />
        </svg>
      );
    case 'chevronRight':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M9.29006 6.70999C8.90006 7.09999 8.90006 7.72999 9.29006 8.11999L13.1701 12L9.29006 15.88C8.90006 16.27 8.90006 16.9 9.29006 17.29C9.68006 17.68 10.3101 17.68 10.7001 17.29L15.2901 12.7C15.6801 12.31 15.6801 11.68 15.2901 11.29L10.7001 6.69999C10.3201 6.31999 9.68006 6.31999 9.29006 6.70999Z" />
        </svg>
      );
    case 'chevronUp':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M11.2902 8.70998L6.70021 13.3C6.31021 13.69 6.31021 14.32 6.70021 14.71C7.09021 15.1 7.72021 15.1 8.11021 14.71L12.0002 10.83L15.8802 14.71C16.2702 15.1 16.9002 15.1 17.2902 14.71C17.6802 14.32 17.6802 13.69 17.2902 13.3L12.7002 8.70998C12.3202 8.31998 11.6802 8.31998 11.2902 8.70998Z" />
        </svg>
      );
    case 'chevronDown':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M15.88 9.29L12 13.17L8.11998 9.29C7.72998 8.9 7.09998 8.9 6.70998 9.29C6.31998 9.68 6.31998 10.31 6.70998 10.7L11.3 15.29C11.69 15.68 12.32 15.68 12.71 15.29L17.3 10.7C17.69 10.31 17.69 9.68 17.3 9.29C16.91 8.91 16.27 8.9 15.88 9.29Z" />
        </svg>
      );
    case 'helpCircled':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M12.1 17.825C12.3667 17.825 12.5917 17.7333 12.775 17.55C12.9583 17.3667 13.05 17.1417 13.05 16.875C13.05 16.6083 12.9583 16.3833 12.775 16.2C12.5917 16.0167 12.3667 15.925 12.1 15.925C11.8333 15.925 11.6083 16.0167 11.425 16.2C11.2417 16.3833 11.15 16.6083 11.15 16.875C11.15 17.1417 11.2417 17.3667 11.425 17.55C11.6083 17.7333 11.8333 17.825 12.1 17.825ZM11.225 14.175H12.7C12.7 13.7417 12.7542 13.3458 12.8625 12.9875C12.9708 12.6292 13.3083 12.2167 13.875 11.75C14.3917 11.3167 14.7583 10.8917 14.975 10.475C15.1917 10.0583 15.3 9.6 15.3 9.1C15.3 8.21667 15.0125 7.50833 14.4375 6.975C13.8625 6.44167 13.1 6.175 12.15 6.175C11.3333 6.175 10.6125 6.37917 9.9875 6.7875C9.3625 7.19583 8.90833 7.75833 8.625 8.475L9.95 8.975C10.1333 8.50833 10.4083 8.14583 10.775 7.8875C11.1417 7.62917 11.575 7.5 12.075 7.5C12.6417 7.5 13.1 7.65417 13.45 7.9625C13.8 8.27083 13.975 8.66667 13.975 9.15C13.975 9.51667 13.8667 9.8625 13.65 10.1875C13.4333 10.5125 13.1167 10.85 12.7 11.2C12.2 11.6333 11.8292 12.0625 11.5875 12.4875C11.3458 12.9125 11.225 13.475 11.225 14.175ZM12 22C10.6333 22 9.34167 21.7375 8.125 21.2125C6.90833 20.6875 5.84583 19.9708 4.9375 19.0625C4.02917 18.1542 3.3125 17.0917 2.7875 15.875C2.2625 14.6583 2 13.3667 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.02917 5.825 4.9375 4.925C5.84583 4.025 6.90833 3.3125 8.125 2.7875C9.34167 2.2625 10.6333 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3667 21.7375 14.6583 21.2125 15.875C20.6875 17.0917 19.975 18.1542 19.075 19.0625C18.175 19.9708 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20.5C14.3667 20.5 16.375 19.6708 18.025 18.0125C19.675 16.3542 20.5 14.35 20.5 12C20.5 9.63333 19.675 7.625 18.025 5.975C16.375 4.325 14.3667 3.5 12 3.5C9.65 3.5 7.64583 4.325 5.9875 5.975C4.32917 7.625 3.5 9.63333 3.5 12C3.5 14.35 4.32917 16.3542 5.9875 18.0125C7.64583 19.6708 9.65 20.5 12 20.5Z" />
        </svg>
      );
    case 'infoCircled':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M11.325 17H12.825V11H11.325V17ZM12 9.15C12.2333 9.15 12.4292 9.075 12.5875 8.925C12.7458 8.775 12.825 8.58333 12.825 8.35C12.825 8.11667 12.7458 7.91667 12.5875 7.75C12.4292 7.58333 12.2333 7.5 12 7.5C11.7667 7.5 11.5708 7.58333 11.4125 7.75C11.2542 7.91667 11.175 8.11667 11.175 8.35C11.175 8.58333 11.2542 8.775 11.4125 8.925C11.5708 9.075 11.7667 9.15 12 9.15ZM12 22C10.6333 22 9.34167 21.7375 8.125 21.2125C6.90833 20.6875 5.84583 19.9708 4.9375 19.0625C4.02917 18.1542 3.3125 17.0917 2.7875 15.875C2.2625 14.6583 2 13.3583 2 11.975C2 10.6083 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.02917 5.825 4.9375 4.925C5.84583 4.025 6.90833 3.3125 8.125 2.7875C9.34167 2.2625 10.6417 2 12.025 2C13.3917 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3667 21.7375 14.6583 21.2125 15.875C20.6875 17.0917 19.975 18.1542 19.075 19.0625C18.175 19.9708 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12.025 20.5C14.375 20.5 16.375 19.6708 18.025 18.0125C19.675 16.3542 20.5 14.3417 20.5 11.975C20.5 9.625 19.675 7.625 18.025 5.975C16.375 4.325 14.3667 3.5 12 3.5C9.65 3.5 7.64583 4.325 5.9875 5.975C4.32917 7.625 3.5 9.63333 3.5 12C3.5 14.35 4.32917 16.3542 5.9875 18.0125C7.64583 19.6708 9.65833 20.5 12.025 20.5Z" />
        </svg>
      );
    case 'plus':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_52_3055)">
            <path d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z" />
          </g>
          <defs>
            <clipPath id="clip0_52_3055">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'australia':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.99228 2.45139L10.7723 2.25348C11.0472 2.18373 11.2756 1.99295 11.3932 1.73481L11.461 1.58603C11.6129 1.25256 11.9455 1.03857 12.3119 1.03857H13.337C13.835 1.03857 14.2456 1.42895 14.2708 1.92634C14.278 2.06936 14.2523 2.21214 14.1956 2.34367L13.9079 3.01112C13.7359 3.41017 13.8735 3.87517 14.235 4.11639L15.4248 4.91021C15.9012 5.22812 16.5494 5.02618 16.7611 4.49397L17.046 3.77734C17.0664 3.72606 17.0791 3.67197 17.0835 3.61693L17.1981 2.20187C17.2243 1.87848 17.4944 1.62934 17.8189 1.62934C18.0786 1.62934 18.3111 1.7905 18.4022 2.03373L18.8462 3.21943C18.895 3.3497 18.986 3.4599 19.1047 3.53242L19.6901 3.89012C19.8396 3.98153 19.9373 4.13814 19.9535 4.3127L20.0768 5.63743C20.125 6.15554 20.3528 6.64051 20.7207 7.00843L21.411 7.69872C21.6142 7.90192 21.7965 8.12509 21.9551 8.36481L23.7278 11.0445C23.9782 11.4231 24.0605 11.8884 23.9551 12.3299L23.25 15.2826C23.2341 15.3491 23.2061 15.4122 23.1672 15.4686L21.9282 17.2682C21.262 18.2357 20.2046 18.8618 19.036 18.9806C18.0865 19.0772 17.1297 18.891 16.2856 18.4455L15.8449 18.2129C15.6686 18.1199 15.5409 17.9554 15.4946 17.7616L15.1808 16.4494C15.0695 15.9841 14.531 15.7691 14.1298 16.0299C13.9496 16.147 13.7179 16.1497 13.535 16.0366L10.9497 14.4384C10.8279 14.3632 10.6819 14.3378 10.5419 14.3676L8.25589 14.8539C8.17475 14.8712 8.09853 14.9064 8.03277 14.957L6.80638 15.9004C6.72331 15.9643 6.62384 16.0034 6.5195 16.0132L5.13008 16.1434C4.97277 16.1582 4.82159 16.2118 4.69011 16.2994L3.36073 17.1857C2.9825 17.4378 2.47888 17.3879 2.15745 17.0665C1.88333 16.7923 1.80242 16.3794 1.95289 16.0221L1.98894 15.9365C2.09239 15.6908 2.08827 15.413 1.97755 15.1704L0.1835 11.2407C-0.058187 10.7113 -0.0612808 10.1036 0.17511 9.57179C0.368329 9.13698 0.708079 8.78378 1.13506 8.57378L2.77873 7.76542C3.50258 7.40945 4.11838 6.86687 4.5627 6.19361L4.70984 5.97067C4.90409 5.67634 5.13195 5.40568 5.38892 5.16414L7.31159 3.35682C7.52272 3.15836 7.85089 3.1555 8.06544 3.35017L8.47695 3.72353C8.57914 3.81629 8.71222 3.86767 8.85027 3.86767C9.08942 3.86767 9.30172 3.71467 9.37733 3.48779L9.60186 2.8142C9.66167 2.63467 9.80881 2.49793 9.99228 2.45139ZM17.5017 21.1358C17.6587 20.7956 18.0806 20.6865 18.4497 20.6216C18.9221 20.5385 19.967 20.3967 20.4298 20.6072C20.9296 20.8344 21.196 21.9719 20.9145 22.4221C20.8582 22.5122 20.7533 22.5576 20.6542 22.5961C20.3385 22.7185 20.0159 22.8231 19.6884 22.9091C19.5336 22.9497 19.3688 22.9862 19.2156 22.9397C19.0191 22.8802 18.9002 22.7091 18.7792 22.5351C18.6898 22.4064 18.5992 22.2762 18.4754 22.1883C18.3601 22.1065 18.2224 22.0662 18.085 22.0261C17.938 21.9831 17.7914 21.9403 17.6726 21.8468C17.4661 21.6842 17.3916 21.3745 17.5017 21.1358Z"
            fill="#B1B0BD"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.2497 15.2824L23.9547 12.3298C24.06 11.8882 23.9779 11.4229 23.7276 11.0446L21.9549 8.36495C21.7964 8.12481 21.6138 7.90206 21.4108 7.69867L20.7204 7.0082C20.3527 6.64056 20.1246 6.15545 20.0763 5.63748L19.9531 4.31265C19.9372 4.13823 19.8395 3.98167 19.6898 3.88988L19.1047 3.53232C18.9858 3.45985 18.895 3.3497 18.8462 3.21924L18.4021 2.03354C18.3108 1.79054 18.0784 1.62915 17.8184 1.62915C17.6566 1.62915 17.5078 1.69145 17.3966 1.79438C17.3464 1.84028 17.3043 1.89442 17.2715 1.95479C17.3198 2.0094 17.358 2.07268 17.3841 2.14323L17.8281 3.32893C17.877 3.45938 17.9678 3.56954 18.0866 3.64201L18.6723 3.99948C18.8216 4.09079 18.9192 4.24735 18.9356 4.42224L19.0588 5.7466C19.1072 6.26504 19.3347 6.75015 19.7029 7.11784L20.3928 7.80831C20.5962 8.01123 20.7784 8.23445 20.9369 8.47412L22.7096 11.1538C22.9604 11.5326 23.0425 11.9979 22.9372 12.4395L22.2318 15.3921C22.2158 15.4588 22.1877 15.5216 22.1491 15.5782L20.9103 17.3775C20.5769 17.8616 20.1459 18.2597 19.6526 18.5521C19.3042 18.7584 18.924 18.9121 18.5253 19.0053C18.6949 19.0062 18.8655 18.998 19.0356 18.9806C19.6202 18.9212 20.1763 18.7351 20.6701 18.4424C21.1639 18.1506 21.5944 17.7519 21.9278 17.2683L23.1671 15.4685C23.2058 15.4119 23.2338 15.3491 23.2497 15.2824ZM20.6539 22.5956C20.753 22.5574 20.8578 22.512 20.9139 22.4217C21.1956 21.9718 20.9293 20.834 20.4293 20.6069C20.121 20.4668 19.5553 20.4827 19.0721 20.5334C19.2499 20.5518 19.4084 20.5856 19.5311 20.6417C20.1017 20.9011 20.4056 22.1994 20.0848 22.7135C20.0529 22.7642 20.0075 22.8024 19.9562 22.8333C20.1915 22.7642 20.4244 22.6845 20.6539 22.5956Z"
            fill="#8894BD"
          />
        </svg>
      );
    case 'close':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M18.3002 5.70997C17.9102 5.31997 17.2802 5.31997 16.8902 5.70997L12.0002 10.59L7.11022 5.69997C6.72022 5.30997 6.09021 5.30997 5.70021 5.69997C5.31021 6.08997 5.31021 6.71997 5.70021 7.10997L10.5902 12L5.70021 16.89C5.31021 17.28 5.31021 17.91 5.70021 18.3C6.09021 18.69 6.72022 18.69 7.11022 18.3L12.0002 13.41L16.8902 18.3C17.2802 18.69 17.9102 18.69 18.3002 18.3C18.6902 17.91 18.6902 17.28 18.3002 16.89L13.4102 12L18.3002 7.10997C18.6802 6.72997 18.6802 6.08997 18.3002 5.70997Z" />
        </svg>
      );
    case 'sort':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M16 17.01V11C16 10.45 15.55 10 15 10C14.45 10 14 10.45 14 11V17.01H12.21C11.76 17.01 11.54 17.55 11.86 17.86L14.65 20.64C14.85 20.83 15.16 20.83 15.36 20.64L18.15 17.86C18.47 17.55 18.24 17.01 17.8 17.01H16ZM8.65003 3.35002L5.86003 6.14002C5.54003 6.45002 5.76003 6.99002 6.21003 6.99002H8.00003V13C8.00003 13.55 8.45003 14 9.00003 14C9.55003 14 10 13.55 10 13V6.99002H11.79C12.24 6.99002 12.46 6.45002 12.14 6.14002L9.35003 3.35002C9.16003 3.16002 8.84003 3.16002 8.65003 3.35002Z" />
        </svg>
      );
    case 'happyFace':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M8.88 9.94L9.41 10.47C9.7 10.76 10.18 10.76 10.47 10.47C10.76 10.18 10.76 9.7 10.47 9.41L9.59 8.53C9.2 8.14 8.57 8.14 8.18 8.53L7.29 9.41C7 9.7 7 10.18 7.29 10.47C7.58 10.76 8.06 10.76 8.35 10.47L8.88 9.94ZM12 17.5C14.03 17.5 15.8 16.39 16.75 14.75C16.94 14.42 16.7 14 16.31 14H7.69C7.31 14 7.06 14.42 7.25 14.75C8.2 16.39 9.97 17.5 12 17.5ZM13.53 10.47C13.82 10.76 14.3 10.76 14.59 10.47L15.12 9.94L15.65 10.47C15.94 10.76 16.42 10.76 16.71 10.47C17 10.18 17 9.7 16.71 9.41L15.83 8.53C15.44 8.14 14.81 8.14 14.42 8.53L13.54 9.41C13.24 9.7 13.24 10.18 13.53 10.47ZM11.99 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 11.99 22C17.51 22 22 17.53 22 12C22 6.47 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z" />
        </svg>
      );
    case 'satisfiedFace':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M15.5 11C16.3284 11 17 10.3284 17 9.5C17 8.67157 16.3284 8 15.5 8C14.6716 8 14 8.67157 14 9.5C14 10.3284 14.6716 11 15.5 11Z" />
          <path d="M8.5 11C9.32843 11 10 10.3284 10 9.5C10 8.67157 9.32843 8 8.5 8C7.67157 8 7 8.67157 7 9.5C7 10.3284 7.67157 11 8.5 11Z" />
          <path d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM16.41 13.89C16.06 13.67 15.59 13.78 15.38 14.13C14.64 15.3 13.38 16 12 16C10.62 16 9.36 15.3 8.62 14.12C8.4 13.77 7.94 13.66 7.59 13.88C7.24 14.1 7.13 14.56 7.35 14.91C8.37 16.54 10.1 17.5 12 17.5C13.9 17.5 15.63 16.53 16.65 14.92C16.87 14.57 16.76 14.11 16.41 13.89Z" />
        </svg>
      );
    case 'sadFace':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M15.5 11C16.3284 11 17 10.3284 17 9.5C17 8.67157 16.3284 8 15.5 8C14.6716 8 14 8.67157 14 9.5C14 10.3284 14.6716 11 15.5 11Z" />
          <path d="M8.5 11C9.32843 11 10 10.3284 10 9.5C10 8.67157 9.32843 8 8.5 8C7.67157 8 7 8.67157 7 9.5C7 10.3284 7.67157 11 8.5 11Z" />
          <path d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM12 14C10.1 14 8.37 14.97 7.35 16.58C7.13 16.93 7.24 17.39 7.59 17.61C7.94 17.83 8.4 17.72 8.62 17.37C9.36 16.19 10.62 15.49 12 15.49C13.38 15.49 14.64 16.19 15.38 17.37C15.52 17.6 15.77 17.72 16.02 17.72C16.16 17.72 16.29 17.68 16.42 17.61C16.77 17.39 16.88 16.93 16.66 16.58C15.63 14.96 13.9 14 12 14Z" />
        </svg>
      );
    case 'checkboxFill':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM10.71 16.29C10.32 16.68 9.69 16.68 9.3 16.29L5.71 12.7C5.32 12.31 5.32 11.68 5.71 11.29C6.1 10.9 6.73 10.9 7.12 11.29L10 14.17L16.88 7.29C17.27 6.9 17.9 6.9 18.29 7.29C18.68 7.68 18.68 8.31 18.29 8.7L10.71 16.29Z" />
        </svg>
      );
    case 'download':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_30_3131)">
            <path d="M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM17 11L15.59 9.59L13 12.17V4H11V12.17L8.41 9.59L7 11L12 16L17 11Z" />
          </g>
          <defs>
            <clipPath id="clip0_30_3131">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'upload':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_30_3160)">
            <path d="M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM7 9L8.41 10.41L11 7.83V16H13V7.83L15.59 10.41L17 9L12 4L7 9Z" />
          </g>
          <defs>
            <clipPath id="clip0_30_3160">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'checkboxEmpty':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M18 19H6C5.45 19 5 18.55 5 18V6C5 5.45 5.45 5 6 5H18C18.55 5 19 5.45 19 6V18C19 18.55 18.55 19 18 19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z" />
        </svg>
      );
    case 'attach':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M16.5 6.75002V17.33C16.5 19.42 14.97 21.28 12.89 21.48C10.5 21.71 8.5 19.84 8.5 17.5V5.14002C8.5 3.83002 9.44 2.64002 10.74 2.51002C12.24 2.36002 13.5 3.53002 13.5 5.00002V15.5C13.5 16.05 13.05 16.5 12.5 16.5C11.95 16.5 11.5 16.05 11.5 15.5V6.75002C11.5 6.34002 11.16 6.00002 10.75 6.00002C10.34 6.00002 10 6.34002 10 6.75002V15.36C10 16.67 10.94 17.86 12.24 17.99C13.74 18.14 15 16.97 15 15.5V5.17002C15 3.08002 13.47 1.22002 11.39 1.02002C9.01 0.790024 7 2.66002 7 5.00002V17.27C7 20.14 9.1 22.71 11.96 22.98C15.25 23.28 18 20.72 18 17.5V6.75002C18 6.34002 17.66 6.00002 17.25 6.00002C16.84 6.00002 16.5 6.34002 16.5 6.75002Z" />
        </svg>
      );
    case 'share':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M18 16.08C17.24 16.08 16.56 16.38 16.04 16.85L8.91 12.7C8.96 12.47 9 12.24 9 12C9 11.76 8.96 11.53 8.91 11.3L15.96 7.19C16.5 7.69 17.21 8 18 8C19.66 8 21 6.66 21 5C21 3.34 19.66 2 18 2C16.34 2 15 3.34 15 5C15 5.24 15.04 5.47 15.09 5.7L8.04 9.81C7.5 9.31 6.79 9 6 9C4.34 9 3 10.34 3 12C3 13.66 4.34 15 6 15C6.79 15 7.5 14.69 8.04 14.19L15.16 18.35C15.11 18.56 15.08 18.78 15.08 19C15.08 20.61 16.39 21.92 18 21.92C19.61 21.92 20.92 20.61 20.92 19C20.92 17.39 19.61 16.08 18 16.08Z" />
        </svg>
      );
    case 'pending':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM11.78 7H11.72C11.32 7 11 7.32 11 7.72V12.44C11 12.79 11.18 13.12 11.49 13.3L15.64 15.79C15.98 15.99 16.42 15.89 16.62 15.55C16.83 15.21 16.72 14.76 16.37 14.56L12.5 12.26V7.72C12.5 7.32 12.18 7 11.78 7Z" />
        </svg>
      );
    case 'emailOutline':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM19 18H5C4.45 18 4 17.55 4 17V8L10.94 12.34C11.59 12.75 12.41 12.75 13.06 12.34L20 8V17C20 17.55 19.55 18 19 18ZM12 11L4 6H20L12 11Z" />
        </svg>
      );
    case 'externalLink':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M9 5V7H15.59L4 18.59L5.41 20L17 8.41V15H19V5H9Z" />
        </svg>
      );
    case 'protection':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M10.9 15.325L16.6 9.62498L15.55 8.59998L10.975 13.175L8.45 10.65L7.35 11.75L10.9 15.325ZM12 21.975C9.66667 21.3916 7.75 20.0375 6.25 17.9125C4.75 15.7875 4 13.4583 4 10.925V4.97498L12 1.97498L20 4.97498V10.925C20 13.4583 19.25 15.7875 17.75 17.9125C16.25 20.0375 14.3333 21.3916 12 21.975ZM12 20.425C13.9167 19.7916 15.4792 18.5958 16.6875 16.8375C17.8958 15.0791 18.5 13.1083 18.5 10.925V6.02498L12 3.57498L5.5 6.02498V10.925C5.5 13.1083 6.10417 15.0791 7.3125 16.8375C8.52083 18.5958 10.0833 19.7916 12 20.425Z" />
        </svg>
      );
    case 'error':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 10.15 4.63 8.45 5.69 7.1L16.9 18.31C15.55 19.37 13.85 20 12 20ZM18.31 16.9L7.1 5.69C8.45 4.63 10.15 4 12 4C16.42 4 20 7.58 20 12C20 13.85 19.37 15.55 18.31 16.9Z" />
        </svg>
      );
    case 'moreHorizontal':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z" />
        </svg>
      );
    case 'notifications':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M4 19V17.5H6.1V9.85C6.1 8.45 6.5125 7.20417 7.3375 6.1125C8.1625 5.02083 9.25 4.33333 10.6 4.05V3.325C10.6 2.94167 10.7375 2.625 11.0125 2.375C11.2875 2.125 11.6167 2 12 2C12.3833 2 12.7125 2.125 12.9875 2.375C13.2625 2.625 13.4 2.94167 13.4 3.325V4.05C14.75 4.33333 15.8417 5.02083 16.675 6.1125C17.5083 7.20417 17.925 8.45 17.925 9.85V17.5H20V19H4ZM12 22C11.4667 22 11 21.8042 10.6 21.4125C10.2 21.0208 10 20.55 10 20H14C14 20.55 13.8042 21.0208 13.4125 21.4125C13.0208 21.8042 12.55 22 12 22ZM7.6 17.5H16.425V9.85C16.425 8.61667 16 7.56667 15.15 6.7C14.3 5.83333 13.2583 5.4 12.025 5.4C10.7917 5.4 9.74583 5.83333 8.8875 6.7C8.02917 7.56667 7.6 8.61667 7.6 9.85V17.5Z" />
        </svg>
      );
    case 'moreVertical':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 16C10.9 16 10 16.9 10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16Z" />
        </svg>
      );
    case 'upgrade':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M16.85 6.85L18.29 8.29L13.41 13.17L10.12 9.88C9.72998 9.49 9.09998 9.49 8.70998 9.88L2.70998 15.89C2.31998 16.28 2.31998 16.91 2.70998 17.3C3.09998 17.69 3.72998 17.69 4.11998 17.3L9.40998 12L12.7 15.29C13.09 15.68 13.72 15.68 14.11 15.29L19.7 9.71L21.14 11.15C21.45 11.46 21.99 11.24 21.99 10.8V6.5C22 6.22 21.78 6 21.5 6H17.21C16.76 6 16.54 6.54 16.85 6.85Z" />
        </svg>
      );
    case 'search':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M15.5001 14H14.7101L14.4301 13.73C15.6301 12.33 16.2501 10.42 15.9101 8.39002C15.4401 5.61002 13.1201 3.39002 10.3201 3.05002C6.09014 2.53002 2.53014 6.09001 3.05014 10.32C3.39014 13.12 5.61014 15.44 8.39014 15.91C10.4201 16.25 12.3301 15.63 13.7301 14.43L14.0001 14.71V15.5L18.2501 19.75C18.6601 20.16 19.3301 20.16 19.7401 19.75C20.1501 19.34 20.1501 18.67 19.7401 18.26L15.5001 14ZM9.50014 14C7.01014 14 5.00014 11.99 5.00014 9.50002C5.00014 7.01002 7.01014 5.00002 9.50014 5.00002C11.9901 5.00002 14.0001 7.01002 14.0001 9.50002C14.0001 11.99 11.9901 14 9.50014 14Z" />
        </svg>
      );
    case 'retry':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M12 20C9.78333 20 7.89583 19.2208 6.3375 17.6625C4.77917 16.1042 4 14.2167 4 12C4 9.78333 4.77917 7.89583 6.3375 6.3375C7.89583 4.77917 9.78333 4 12 4C13.4167 4 14.6583 4.2875 15.725 4.8625C16.7917 5.4375 17.7167 6.225 18.5 7.225V4H20V10.35H13.65V8.85H17.85C17.2167 7.85 16.4083 7.04167 15.425 6.425C14.4417 5.80833 13.3 5.5 12 5.5C10.1833 5.5 8.64583 6.12917 7.3875 7.3875C6.12917 8.64583 5.5 10.1833 5.5 12C5.5 13.8167 6.12917 15.3542 7.3875 16.6125C8.64583 17.8708 10.1833 18.5 12 18.5C13.3833 18.5 14.65 18.1042 15.8 17.3125C16.95 16.5208 17.75 15.475 18.2 14.175H19.75C19.2667 15.925 18.3083 17.3333 16.875 18.4C15.4417 19.4667 13.8167 20 12 20Z" />
        </svg>
      );
    case 'warning':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1 21L12 2L23 21H1ZM3.6 19.5H20.4L12 5L3.6 19.5ZM12.1 18.075C12.3167 18.075 12.4958 18.0042 12.6375 17.8625C12.7792 17.7208 12.85 17.5417 12.85 17.325C12.85 17.1083 12.7792 16.9292 12.6375 16.7875C12.4958 16.6458 12.3167 16.575 12.1 16.575C11.8833 16.575 11.7042 16.6458 11.5625 16.7875C11.4208 16.9292 11.35 17.1083 11.35 17.325C11.35 17.5417 11.4208 17.7208 11.5625 17.8625C11.7042 18.0042 11.8833 18.075 12.1 18.075ZM11.35 15.3H12.85V9.7H11.35V15.3Z" />
        </svg>
      );
    case 'check':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M9.00014 16.17L5.53014 12.7C5.14014 12.31 4.51014 12.31 4.12014 12.7C3.73014 13.09 3.73014 13.72 4.12014 14.11L8.30014 18.29C8.69014 18.68 9.32014 18.68 9.71014 18.29L20.2901 7.71001C20.6801 7.32001 20.6801 6.69001 20.2901 6.30001C19.9001 5.91001 19.2701 5.91001 18.8801 6.30001L9.00014 16.17Z" />
        </svg>
      );
    case 'delete':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_39_3201)">
            <path d="M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z" />
          </g>
          <defs>
            <clipPath id="clip0_39_3201">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'usd':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill="#1743EA"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M11.83 10.7778C9.333 10.1222 8.53 9.44444 8.53 8.38889C8.53 7.17778 9.641 6.33333 11.5 6.33333C13.062 6.33333 13.843 6.93333 14.129 7.88889C14.261 8.33333 14.624 8.66667 15.086 8.66667H15.416C16.142 8.66667 16.659 7.94444 16.406 7.25556C15.944 5.94444 14.866 4.85556 13.15 4.43333V3.66667C13.15 2.74444 12.413 2 11.5 2C10.587 2 9.85 2.74444 9.85 3.66667V4.4C7.716 4.86667 6 6.26667 6 8.41111C6 10.9778 8.101 12.2556 11.17 13C13.92 13.6667 14.47 14.6444 14.47 15.6778C14.47 16.4444 13.931 17.6667 11.5 17.6667C9.685 17.6667 8.75 17.0111 8.387 16.0778C8.222 15.6444 7.848 15.3333 7.397 15.3333H7.089C6.352 15.3333 5.835 16.0889 6.11 16.7778C6.737 18.3222 8.2 19.2333 9.85 19.5889V20.3333C9.85 21.2556 10.587 22 11.5 22C12.413 22 13.15 21.2556 13.15 20.3333V19.6111C15.295 19.2 17 17.9444 17 15.6667C17 12.5111 14.327 11.4333 11.83 10.7778Z" />
        </svg>
      );
    case 'add':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16 13H13V16C13 16.55 12.55 17 12 17C11.45 17 11 16.55 11 16V13H8C7.45 13 7 12.55 7 12C7 11.45 7.45 11 8 11H11V8C11 7.45 11.45 7 12 7C12.55 7 13 7.45 13 8V11H16C16.55 11 17 11.45 17 12C17 12.55 16.55 13 16 13Z" />
        </svg>
      );
    case 'user':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.0001 15.2C11.3744 15.2 10.8727 15.2422 10.4447 15.3049C8.68029 15.5632 7.2001 17.3584 7.2001 19.2C7.2001 19.6418 6.84193 20 6.4001 20C5.95827 20 5.6001 19.6418 5.6001 19.2C5.6001 17.1256 6.90005 15.0879 8.76738 14.1733C7.33505 13.1589 6.4001 11.4887 6.4001 9.6C6.4001 6.50721 8.9073 4 12.0001 4C15.0929 4 17.6001 6.50721 17.6001 9.6C17.6001 11.4887 16.6651 13.1589 15.2328 14.1733C17.1001 15.0879 18.4001 17.1256 18.4001 19.2C18.4001 19.6418 18.0419 20 17.6001 20C17.1583 20 16.8001 19.6418 16.8001 19.2C16.8001 17.3584 15.3199 15.5632 13.5555 15.3049C13.1275 15.2422 12.6258 15.2 12.0001 15.2ZM12.0001 13.6C9.79096 13.6 8.0001 11.8091 8.0001 9.6C8.0001 7.39086 9.79096 5.6 12.0001 5.6C14.2092 5.6 16.0001 7.39086 16.0001 9.6C16.0001 11.8091 14.2092 13.6 12.0001 13.6Z"
          />
        </svg>
      );
    case 'transfer':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_52_3062)">
            <path d="M12 5.99994V7.78994C12 8.23994 12.54 8.45994 12.85 8.13994L15.64 5.34994C15.84 5.14994 15.84 4.83994 15.64 4.63994L12.85 1.84994C12.54 1.53994 12 1.75994 12 2.20994V3.99994C7.58 3.99994 4 7.57994 4 11.9999C4 13.0399 4.2 14.0399 4.57 14.9499C4.84 15.6199 5.7 15.7999 6.21 15.2899C6.48 15.0199 6.59 14.6099 6.44 14.2499C6.15 13.5599 6 12.7899 6 11.9999C6 8.68994 8.69 5.99994 12 5.99994ZM17.79 8.70994C17.52 8.97994 17.41 9.39994 17.56 9.74994C17.84 10.4499 18 11.2099 18 11.9999C18 15.3099 15.31 17.9999 12 17.9999V16.2099C12 15.7599 11.46 15.5399 11.15 15.8599L8.36 18.6499C8.16 18.8499 8.16 19.1599 8.36 19.3599L11.15 22.1499C11.46 22.4599 12 22.2399 12 21.7999V19.9999C16.42 19.9999 20 16.4199 20 11.9999C20 10.9599 19.8 9.95994 19.43 9.04994C19.16 8.37994 18.3 8.19994 17.79 8.70994Z" />
          </g>
          <defs>
            <clipPath id="clip0_52_3062">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'message':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_52_3059)">
            <path d="M20 4V16H5.17L4 17.17V4H20ZM20 2H4C2.9 2 2 2.9 2 4V19.59C2 20.48 3.08 20.93 3.71 20.3L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z" />
          </g>
          <defs>
            <clipPath id="clip0_52_3059">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'copy':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_52_3057)">
            <path d="M15 20H5V7C5 6.45 4.55 6 4 6C3.45 6 3 6.45 3 7V20C3 21.1 3.9 22 5 22H15C15.55 22 16 21.55 16 21C16 20.45 15.55 20 15 20ZM20 16V4C20 2.9 19.1 2 18 2H9C7.9 2 7 2.9 7 4V16C7 17.1 7.9 18 9 18H18C19.1 18 20 17.1 20 16ZM18 16H9V4H18V16Z" />
          </g>
          <defs>
            <clipPath id="clip0_52_3057">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'photoFile':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_52_3060)">
            <path d="M21 19V5C21 3.9 20.1 3 19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19ZM8.9 13.98L11 16.51L14.1 12.52C14.3 12.26 14.7 12.26 14.9 12.53L18.41 17.21C18.66 17.54 18.42 18.01 18.01 18.01H6.02C5.6 18.01 5.37 17.53 5.63 17.2L8.12 14C8.31 13.74 8.69 13.73 8.9 13.98Z" />
          </g>
          <defs>
            <clipPath id="clip0_52_3060">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'database':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_52_3061)">
            <path d="M19 13H5C3.9 13 3 13.9 3 15V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V15C21 13.9 20.1 13 19 13ZM7 19C5.9 19 5 18.1 5 17C5 15.9 5.9 15 7 15C8.1 15 9 15.9 9 17C9 18.1 8.1 19 7 19ZM19 3H5C3.9 3 3 3.9 3 5V9C3 10.1 3.9 11 5 11H19C20.1 11 21 10.1 21 9V5C21 3.9 20.1 3 19 3ZM7 9C5.9 9 5 8.1 5 7C5 5.9 5.9 5 7 5C8.1 5 9 5.9 9 7C9 8.1 8.1 9 7 9Z" />
          </g>
          <defs>
            <clipPath id="clip0_52_3061">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'minus':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M18 13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z" />
        </svg>
      );
    case 'link':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M17 7H14C13.45 7 13 7.45 13 8C13 8.55 13.45 9 14 9H17C18.65 9 20 10.35 20 12C20 13.65 18.65 15 17 15H14C13.45 15 13 15.45 13 16C13 16.55 13.45 17 14 17H17C19.76 17 22 14.76 22 12C22 9.24 19.76 7 17 7ZM8 12C8 12.55 8.45 13 9 13H15C15.55 13 16 12.55 16 12C16 11.45 15.55 11 15 11H9C8.45 11 8 11.45 8 12ZM10 15H7C5.35 15 4 13.65 4 12C4 10.35 5.35 9 7 9H10C10.55 9 11 8.55 11 8C11 7.45 10.55 7 10 7H7C4.24 7 2 9.24 2 12C2 14.76 4.24 17 7 17H10C10.55 17 11 16.55 11 16C11 15.45 10.55 15 10 15Z" />
        </svg>
      );
    case 'arrowTop':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_41_3513)">
            <path d="M4 12L5.41 13.41L11 7.83V20H13V7.83L18.58 13.42L20 12L12 4L4 12Z" />
          </g>
          <defs>
            <clipPath id="clip0_41_3513">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'camera':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_39_3481)">
            <path d="M14.12 4L15.95 6H20V18H4V6H8.05L9.88 4H14.12ZM15 2H9L7.17 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4H16.83L15 2ZM12 9C13.65 9 15 10.35 15 12C15 13.65 13.65 15 12 15C10.35 15 9 13.65 9 12C9 10.35 10.35 9 12 9ZM12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C14.76 17 17 14.76 17 12C17 9.24 14.76 7 12 7Z" />
          </g>
          <defs>
            <clipPath id="clip0_39_3481">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'arrowDown':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_41_3521)">
            <path d="M20 12L18.59 10.59L13 16.17V4H11V16.17L5.42 10.58L4 12L12 20L20 12Z" />
          </g>
          <defs>
            <clipPath id="clip0_41_3521">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'gallery':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_39_3482)">
            <path d="M20 4V16H8V4H20ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM11.5 11.67L13.19 13.93L15.67 10.83L19 15H9L11.5 11.67ZM2 6V20C2 21.1 2.9 22 4 22H18V20H4V6H2Z" />
          </g>
          <defs>
            <clipPath id="clip0_39_3482">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'filter':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_39_3289)">
            <path d="M7.00018 6H17.0002L11.9902 12.3L7.00018 6ZM4.25018 5.61C6.27018 8.2 10.0002 13 10.0002 13V19C10.0002 19.55 10.4502 20 11.0002 20H13.0002C13.5502 20 14.0002 19.55 14.0002 19V13C14.0002 13 17.7202 8.2 19.7402 5.61C20.2502 4.95 19.7802 4 18.9502 4H5.04018C4.21018 4 3.74018 4.95 4.25018 5.61Z" />
          </g>
          <defs>
            <clipPath id="clip0_39_3289">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'arrowRight':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_41_3517)">
            <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" />
          </g>
          <defs>
            <clipPath id="clip0_41_3517">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'arrowLeft':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z" />
        </svg>
      );
    case 'dislike':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_39_3302)">
            <path d="M15 3H6C5.17 3 4.46 3.5 4.16 4.22L1.14 11.27C1.05 11.5 1 11.74 1 12V14C1 15.1 1.9 16 3 16H9.31L8.36 20.57L8.33 20.89C8.33 21.3 8.5 21.68 8.77 21.95L9.83 23L16.42 16.41C16.78 16.05 17 15.55 17 15V5C17 3.9 16.1 3 15 3ZM15 15L10.66 19.34L12 14H3V12L6 5H15V15ZM19 3H23V15H19V3Z" />
          </g>
          <defs>
            <clipPath id="clip0_39_3302">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'location':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_39_3230)">
            <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM7 9C7 6.24 9.24 4 12 4C14.76 4 17 6.24 17 9C17 11.88 14.12 16.19 12 18.88C9.92 16.21 7 11.85 7 9Z" />
            <path d="M12 11.5C13.3807 11.5 14.5 10.3807 14.5 9C14.5 7.61929 13.3807 6.5 12 6.5C10.6193 6.5 9.5 7.61929 9.5 9C9.5 10.3807 10.6193 11.5 12 11.5Z" />
          </g>
          <defs>
            <clipPath id="clip0_39_3230">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'edit':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_39_3213)">
            <path d="M14.06 9.02L14.98 9.94L5.92 19H5V18.08L14.06 9.02ZM17.66 3C17.41 3 17.15 3.1 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C18.17 3.09 17.92 3 17.66 3ZM14.06 6.19L3 17.25V21H6.75L17.81 9.94L14.06 6.19Z" />
          </g>
          <defs>
            <clipPath id="clip0_39_3213">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'faq':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_39_3252)">
            <path d="M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM13.51 10.16C13.92 9.43 14.69 9 15.14 8.36C15.62 7.68 15.35 6.42 14 6.42C13.12 6.42 12.68 7.09 12.5 7.65L11.13 7.08C11.51 5.96 12.52 5 13.99 5C15.22 5 16.07 5.56 16.5 6.26C16.87 6.86 17.08 7.99 16.51 8.83C15.88 9.76 15.28 10.04 14.95 10.64C14.82 10.88 14.77 11.04 14.77 11.82H13.25C13.26 11.41 13.19 10.74 13.51 10.16ZM12.95 13.95C12.95 13.36 13.42 12.91 14 12.91C14.59 12.91 15.04 13.36 15.04 13.95C15.04 14.53 14.6 15 14 15C13.42 15 12.95 14.53 12.95 13.95Z" />
          </g>
          <defs>
            <clipPath id="clip0_39_3252">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'like':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_39_3293)">
            <path d="M9 21H18C18.83 21 19.54 20.5 19.84 19.78L22.86 12.73C22.95 12.5 23 12.26 23 12V10C23 8.9 22.1 8 21 8H14.69L15.64 3.43L15.67 3.11C15.67 2.7 15.5 2.32 15.23 2.05L14.17 1L7.58 7.59C7.22 7.95 7 8.45 7 9V19C7 20.1 7.9 21 9 21ZM9 9L13.34 4.66L12 10H21V12L18 19H9V9ZM1 9H5V21H1V9Z" />
          </g>
          <defs>
            <clipPath id="clip0_39_3293">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case 'addPeople':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.8904 12C19.3968 12 19.8073 12.4105 19.8073 12.9169V16.2789H22.7462C23.2526 16.2789 23.6631 16.6894 23.6631 17.1957C23.6631 17.7021 23.2526 18.1126 22.7462 18.1126H19.8073V21.4746C19.8073 21.981 19.3968 22.3915 18.8904 22.3915C18.3841 22.3915 17.9735 21.981 17.9735 21.4746V18.1126H14.9169C14.4105 18.1126 14 17.7021 14 17.1957C14 16.6894 14.4105 16.2789 14.9169 16.2789H17.9735V12.9169C17.9735 12.4105 18.3841 12 18.8904 12Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.1912 7.6C18.1912 4.50721 15.6559 2 12.5285 2C10.7695 2 9.19781 2.79312 8.15918 4.03748C8.5 4.03 9.5 4.27 10.0001 4.47758C10.6927 3.92846 11.5718 3.6 12.5285 3.6C14.7624 3.6 16.5733 5.39086 16.5733 7.6C16.5733 9.25746 15.5539 10.6795 14.1013 11.2863C14.0849 11.4017 14.0712 11.5115 14.0579 11.6177C13.9891 12.1681 13.9325 12.6204 13.5827 13.2444C13.7677 13.261 13.9397 13.2815 14.1013 13.3049C15.1305 13.4539 16.0641 14.1143 16.6699 15V12.7039C16.3963 12.5004 16.1045 12.322 15.7974 12.1733C17.2458 11.1589 18.1912 9.48865 18.1912 7.6Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.4717 16.2C6.83899 16.2 6.33169 16.2422 5.89887 16.3049C4.1147 16.5632 2.61792 18.3584 2.61792 20.2C2.61792 20.6418 2.25574 21 1.80896 21C1.36218 21 1 20.6418 1 20.2C1 18.1256 2.31451 16.0879 4.20276 15.1733C2.75439 14.1589 1.80896 12.4887 1.80896 10.6C1.80896 7.50721 4.34426 5 7.4717 5C10.5991 5 13.1344 7.50721 13.1344 10.6C13.1344 12.4887 12.189 14.1589 10.7406 15.1733C12.6289 16.0879 13.9434 18.1256 13.9434 20.2C13.9434 20.6418 13.5812 21 13.1344 21C12.6877 21 12.3255 20.6418 12.3255 20.2C12.3255 18.3584 10.8287 16.5632 9.04453 16.3049C8.6117 16.2422 8.1044 16.2 7.4717 16.2ZM7.4717 14.6C5.23781 14.6 3.42689 12.8091 3.42689 10.6C3.42689 8.39086 5.23781 6.6 7.4717 6.6C9.70559 6.6 11.5165 8.39086 11.5165 10.6C11.5165 12.8091 9.70559 14.6 7.4717 14.6Z"
          />
        </svg>
      );
    case 'apiToken':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M12.3841 2.41562C11.6078 2.35314 10.828 2.48049 10.1119 2.78668C9.39582 3.09287 8.76499 3.5687 8.27386 4.17311C7.78272 4.77752 7.44602 5.49237 7.29283 6.25595C7.13963 7.01954 7.17454 7.80893 7.39453 8.55602L2.61013 13.3392C2.47506 13.4741 2.39909 13.6571 2.39893 13.848V17.28C2.39893 17.471 2.47478 17.6541 2.60981 17.7891C2.74484 17.9242 2.92797 18 3.11893 18H6.47893C6.66988 18 6.85302 17.9242 6.98804 17.7891C7.12307 17.6541 7.19893 17.471 7.19893 17.28V15.6H9.47893C9.66988 15.6 9.85302 15.5242 9.98804 15.3891C10.1231 15.2541 10.1989 15.071 10.1989 14.88V12.8484L11.0809 11.9664C10.8224 11.6498 10.5939 11.31 10.3981 10.9512L9.21013 12.1404C9.07506 12.2753 8.99909 12.4583 8.99893 12.6492V14.4H6.72013C6.52917 14.4 6.34604 14.4759 6.21101 14.6109C6.07598 14.7459 6.00013 14.9291 6.00013 15.12V16.8H3.60013V14.0484L8.78413 8.86442L8.64253 8.50082C8.46234 8.03543 8.38085 7.53767 8.40322 7.03912C8.42559 6.54057 8.55134 6.05212 8.77249 5.60474C8.99364 5.15736 9.30536 4.76083 9.68788 4.44031C10.0704 4.11979 10.5154 3.88227 10.9945 3.74282C11.3905 3.23522 11.8585 2.78762 12.3829 2.41562H12.3841ZM16.2001 7.50002C16.3183 7.50002 16.4353 7.47674 16.5445 7.43151C16.6537 7.38628 16.7529 7.31999 16.8365 7.23642C16.9201 7.15284 16.9864 7.05363 17.0316 6.94443C17.0768 6.83524 17.1001 6.71821 17.1001 6.60002C17.1001 6.48183 17.0768 6.3648 17.0316 6.2556C16.9864 6.14641 16.9201 6.0472 16.8365 5.96362C16.7529 5.88005 16.6537 5.81376 16.5445 5.76853C16.4353 5.7233 16.3183 5.70002 16.2001 5.70002C15.9614 5.70002 15.7325 5.79484 15.5637 5.96362C15.3949 6.13241 15.3001 6.36132 15.3001 6.60002C15.3001 6.83871 15.3949 7.06763 15.5637 7.23642C15.7325 7.4052 15.9614 7.50002 16.2001 7.50002ZM10.8001 7.80002C10.8002 6.86711 11.042 5.95014 11.5018 5.13846C11.9617 4.32678 12.624 3.64809 13.4243 3.16852C14.2245 2.68896 15.1353 2.42489 16.0679 2.40205C17.0005 2.37921 17.9232 2.59837 18.7459 3.03817C19.5686 3.47798 20.2634 4.12343 20.7625 4.91162C21.2615 5.69981 21.5479 6.60385 21.5936 7.53564C21.6394 8.46742 21.4429 9.39517 21.0235 10.2285C20.604 11.0617 19.9758 11.7721 19.2001 12.2904V14.7504L20.1397 15.6912C20.2746 15.8262 20.3503 16.0092 20.3503 16.2C20.3503 16.3908 20.2746 16.5738 20.1397 16.7088L18.8485 18L20.1301 19.2804C20.2017 19.3521 20.2574 19.438 20.2935 19.5327C20.3297 19.6273 20.3454 19.7285 20.3397 19.8296C20.3341 19.9308 20.3071 20.0296 20.2607 20.1196C20.2142 20.2096 20.1493 20.2888 20.0701 20.352L17.2501 22.608C17.1224 22.7103 16.9637 22.766 16.8001 22.766C16.6365 22.766 16.4778 22.7103 16.3501 22.608L13.4701 20.304C13.3859 20.2366 13.318 20.1511 13.2712 20.0539C13.2245 19.9567 13.2002 19.8503 13.2001 19.7424V12.2904C12.4614 11.7973 11.8558 11.1295 11.4371 10.3461C11.0184 9.5628 10.7996 8.68822 10.8001 7.80002ZM16.2001 3.60002C15.2752 3.5996 14.376 3.9045 13.6421 4.4674C12.9082 5.0303 12.3807 5.81971 12.1413 6.71312C11.9019 7.60653 11.9642 8.55396 12.3184 9.40837C12.6726 10.2628 13.2989 10.9764 14.1001 11.4384C14.1913 11.4911 14.2671 11.5668 14.3197 11.658C14.3724 11.7492 14.4001 11.8527 14.4001 11.958V19.512L16.8001 21.432L18.9013 19.7508L17.6605 18.5088C17.5257 18.3738 17.45 18.1908 17.45 18C17.45 17.8092 17.5257 17.6262 17.6605 17.4912L18.9517 16.2L18.2113 15.4596C18.0763 15.3247 18.0003 15.1417 18.0001 14.9508V11.958C18.0001 11.8527 18.0279 11.7492 18.0805 11.658C18.1332 11.5668 18.2089 11.4911 18.3001 11.4384C19.1014 10.9764 19.7277 10.2628 20.0819 9.40837C20.4361 8.55396 20.4983 7.60653 20.2589 6.71312C20.0196 5.81971 19.492 5.0303 18.7581 4.4674C18.0242 3.9045 17.125 3.5996 16.2001 3.60002Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.053 2.64873C10.7915 2.33298 11.5957 2.20165 12.3963 2.26608L12.3899 2.42524L12.4698 2.53794C11.9574 2.90146 11.5 3.33892 11.1129 3.83506L11.0831 3.87328L11.0365 3.88682C10.5773 4.02046 10.1509 4.24809 9.78432 4.55526C9.41773 4.86243 9.119 5.24244 8.90706 5.67119C8.69512 6.09993 8.57461 6.56804 8.55317 7.04582C8.53173 7.52356 8.60981 8.00053 8.78245 8.44649C8.78247 8.44654 8.78243 8.44644 8.78245 8.44649L8.95954 8.90122L3.75022 14.1105V16.65H5.85022V15.12C5.85022 14.8893 5.94188 14.668 6.10504 14.5048C6.2682 14.3417 6.48948 14.25 6.72022 14.25H8.84902V12.6492C8.84923 12.4185 8.94102 12.1973 9.10422 12.0343L10.4338 10.7033L10.5299 10.8794C10.7212 11.23 10.9446 11.5621 11.1972 11.8715L11.283 11.9766L10.349 12.9105V14.88C10.349 15.1107 10.2574 15.332 10.0942 15.4952C9.93105 15.6583 9.70976 15.75 9.47902 15.75H7.34902V17.28C7.34902 17.5107 7.25736 17.732 7.09421 17.8952C6.93105 18.0583 6.70976 18.15 6.47902 18.15H3.11902C2.88829 18.15 2.667 18.0583 2.50384 17.8952C2.34068 17.732 2.24902 17.5107 2.24902 17.28V13.848C2.24923 13.6173 2.34102 13.3961 2.50422 13.2331L7.22622 8.51225C7.02146 7.76744 6.99375 6.98459 7.14586 6.22642C7.30384 5.43897 7.65105 4.70179 8.15754 4.07849C8.66403 3.45519 9.31457 2.96449 10.053 2.64873ZM11.9571 2.55031C11.3442 2.55585 10.737 2.68254 10.171 2.92457C9.47727 3.22119 8.86616 3.68216 8.39037 4.26768C7.91458 4.85321 7.5884 5.54571 7.43999 6.28543C7.29159 7.02516 7.3254 7.78989 7.53852 8.51362L7.56368 8.59909L2.71628 13.4453C2.60936 13.5521 2.54917 13.697 2.54902 13.8481V17.28C2.54902 17.4312 2.60908 17.5761 2.71597 17.683C2.82287 17.7899 2.96785 17.85 3.11902 17.85H6.47902C6.6302 17.85 6.77518 17.7899 6.88207 17.683C6.98897 17.5761 7.04902 17.4312 7.04902 17.28V15.45H9.47902C9.6302 15.45 9.77518 15.3899 9.88207 15.283C9.98897 15.1762 10.049 15.0312 10.049 14.88V12.7863L10.88 11.9553C10.6913 11.7144 10.5192 11.461 10.3648 11.1969L9.31634 12.2464C9.20942 12.3532 9.14916 12.4982 9.14902 12.6493V14.55H6.72022C6.56905 14.55 6.42407 14.61 6.31717 14.7169C6.21028 14.8238 6.15022 14.9688 6.15022 15.12V16.95H3.45022V13.9863L8.60891 8.82758L8.50285 8.55523C8.31516 8.07046 8.23016 7.55169 8.25347 7.03237C8.27677 6.51306 8.40776 6.00425 8.63812 5.53824C8.86848 5.07223 9.19319 4.65919 9.59164 4.32531C9.97766 4.00185 10.4247 3.75954 10.9061 3.61266C11.2165 3.2206 11.5691 2.86415 11.9571 2.55031ZM18.6753 3.17044C17.8754 2.74284 16.9784 2.52977 16.0717 2.55198C15.1649 2.57419 14.2794 2.83092 13.5015 3.29716C12.7235 3.7634 12.0796 4.42324 11.6324 5.21238C11.1853 6.00151 10.9503 6.89301 10.9502 7.80001C10.9497 8.66351 11.1625 9.51385 11.5695 10.2754C11.9765 11.037 12.5653 11.6862 13.2835 12.1656L13.3502 12.2102V19.7423C13.3503 19.8277 13.3695 19.912 13.4065 19.9889C13.4435 20.0659 13.4973 20.1335 13.564 20.1869L16.4439 22.4909C16.545 22.5718 16.6707 22.6159 16.8002 22.6159C16.9297 22.6159 17.0554 22.5718 17.1565 22.4909L19.9765 20.2349C20.0392 20.1848 20.0907 20.122 20.1275 20.0508C20.1643 19.9795 20.1856 19.9013 20.1901 19.8212C20.1945 19.7412 20.1821 19.661 20.1535 19.5861C20.1249 19.5112 20.0808 19.4432 20.0241 19.3864L18.6364 18L20.0337 16.6028C20.1404 16.4959 20.2004 16.351 20.2004 16.2C20.2004 16.0489 20.1404 15.9041 20.0337 15.7972L19.0502 14.8125V12.2102L19.1169 12.1657C19.871 11.6618 20.4818 10.9711 20.8896 10.161C21.2974 9.35084 21.4884 8.44887 21.4439 7.54297C21.3994 6.63707 21.121 5.75814 20.6358 4.99184C20.1506 4.22555 19.4752 3.59803 18.6753 3.17044ZM16.0643 2.25207C17.0229 2.22859 17.9711 2.45384 18.8167 2.90587C19.6623 3.35789 20.3763 4.02127 20.8893 4.83135C21.4022 5.64144 21.6965 6.57059 21.7435 7.52826C21.7906 8.48593 21.5887 9.43944 21.1576 10.2959C20.7385 11.1283 20.1168 11.8414 19.3502 12.3699V14.6883L20.246 15.5852C20.4089 15.7483 20.5004 15.9694 20.5004 16.2C20.5004 16.4305 20.4089 16.6517 20.246 16.8148L19.0608 17.9999L20.2362 19.1743C20.3228 19.2609 20.3901 19.3648 20.4338 19.4792C20.4774 19.5935 20.4964 19.7158 20.4896 19.838C20.4828 19.9602 20.4502 20.0796 20.3941 20.1884C20.3379 20.2971 20.2595 20.3928 20.1638 20.4692L17.344 22.7251C17.1897 22.8486 16.9979 22.9159 16.8002 22.9159C16.6026 22.9159 16.4108 22.8486 16.2565 22.7251L13.3765 20.4211C13.2748 20.3397 13.1926 20.2364 13.1361 20.1189C13.0797 20.0015 13.0503 19.8728 13.0502 19.7425V12.3699C12.3212 11.8678 11.7226 11.1982 11.3049 10.4168C10.8746 9.6117 10.6497 8.71281 10.6502 7.79991C10.6502 7.79989 10.6502 7.79994 10.6502 7.79991C10.6503 6.84112 10.8988 5.89869 11.3714 5.06449C11.8441 4.23026 12.5248 3.53272 13.3472 3.03984C14.1697 2.54695 15.1058 2.27555 16.0643 2.25207ZM13.5509 4.34836C14.311 3.76537 15.2423 3.44958 16.2002 3.44999C17.1581 3.44958 18.0894 3.76537 18.8495 4.34836C19.6096 4.93136 20.156 5.74896 20.4039 6.67428C20.6518 7.59959 20.5874 8.58086 20.2205 9.46578C19.8537 10.3507 19.205 11.0898 18.3752 11.5683C18.3068 11.6078 18.25 11.6646 18.2105 11.733C18.171 11.8014 18.1502 11.879 18.1502 11.958V14.9507C18.1504 15.1018 18.2105 15.2467 18.3174 15.3535L19.164 16.2L17.7668 17.5972C17.66 17.7041 17.6001 17.8489 17.6001 18C17.6001 18.151 17.66 18.2959 17.7668 18.4028L19.1259 19.7633L16.8002 21.6241L14.2502 19.5841V11.958C14.2502 11.879 14.2294 11.8014 14.1899 11.733C14.1504 11.6646 14.0937 11.6078 14.0253 11.5683C13.1954 11.0898 12.5468 10.3507 12.1799 9.46578C11.8131 8.58086 11.7486 7.59959 11.9965 6.67428C12.2444 5.74896 12.7908 4.93136 13.5509 4.34836ZM16.2002 3.74999C15.3083 3.74959 14.4412 4.0436 13.7335 4.5864C13.0258 5.1292 12.5171 5.89041 12.2863 6.75191C12.0555 7.61341 12.1155 8.52701 12.457 9.3509C12.7986 10.1748 13.4025 10.8629 14.1752 11.3085C14.2892 11.3743 14.3839 11.469 14.4497 11.583C14.5156 11.697 14.5502 11.8263 14.5502 11.958V19.4399L16.8002 21.2399L18.6769 19.7383L17.5545 18.6148C17.3916 18.4517 17.3001 18.2305 17.3001 18C17.3001 17.7694 17.3916 17.5483 17.5545 17.3852L18.7397 16.2L18.1054 15.5657C17.9422 15.4027 17.8504 15.1816 17.8502 14.9509V11.958C17.8502 11.8263 17.8849 11.697 17.9507 11.583C18.0165 11.469 18.1112 11.3743 18.2252 11.3085C18.9978 10.863 19.6019 10.1748 19.9434 9.3509C20.2849 8.52701 20.345 7.61341 20.1142 6.75191C19.8833 5.89041 19.3746 5.12919 18.6669 4.5864C17.9592 4.0436 17.092 3.74959 16.2002 3.74999ZM15.4578 5.85753C15.6547 5.66062 15.9217 5.54999 16.2002 5.54999C16.3381 5.54999 16.4747 5.57715 16.602 5.62992C16.7294 5.68269 16.8452 5.76003 16.9427 5.85753C17.0402 5.95503 17.1175 6.07079 17.1703 6.19818C17.2231 6.32557 17.2502 6.46211 17.2502 6.59999C17.2502 6.73788 17.2231 6.87442 17.1703 7.00181C17.1175 7.1292 17.0402 7.24496 16.9427 7.34246C16.8452 7.43996 16.7294 7.5173 16.602 7.57007C16.4747 7.62284 16.3381 7.64999 16.2002 7.64999C15.9217 7.64999 15.6547 7.53937 15.4578 7.34246C15.2608 7.14554 15.1502 6.87847 15.1502 6.59999C15.1502 6.32152 15.2608 6.05445 15.4578 5.85753ZM16.2002 5.84999C16.0013 5.84999 15.8105 5.92901 15.6699 6.06966C15.5292 6.21032 15.4502 6.40108 15.4502 6.59999C15.4502 6.79891 15.5292 6.98967 15.6699 7.13032C15.8105 7.27098 16.0013 7.34999 16.2002 7.34999C16.2987 7.34999 16.3962 7.3306 16.4872 7.2929C16.5782 7.25521 16.6609 7.19997 16.7306 7.13032C16.8002 7.06068 16.8554 6.978 16.8931 6.88701C16.9308 6.79601 16.9502 6.69849 16.9502 6.59999C16.9502 6.5015 16.9308 6.40398 16.8931 6.31298C16.8554 6.22199 16.8002 6.13931 16.7306 6.06966C16.6609 6.00002 16.5782 5.94478 16.4872 5.90708C16.3962 5.86939 16.2987 5.84999 16.2002 5.84999Z"
          />
        </svg>
      );
    case 'shield':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.9654 5.09471C16.5262 4.32356 15.1042 3.7524 12 2C8.89576 3.7524 7.47383 4.32356 4.03458 5.09471C3.4115 17.4389 11.4069 21.7014 12 22C12.5931 21.7014 20.5885 17.4389 19.9654 5.09471Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'logOut':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.375 19.5H4.875C4.37772 19.5 3.90081 19.3025 3.54917 18.9508C3.19754 18.5992 3 18.1223 3 17.625V6.375C3 5.87772 3.19754 5.40081 3.54917 5.04917C3.90081 4.69754 4.37772 4.5 4.875 4.5H10M17.25 15.75L21 12L17.25 8.25M8.25 12H20.25"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'send':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_1190_36067)">
            <path d="M19.0808 2.69813L19.0744 2.70065L2.18494 9.68709C2.0425 9.74547 1.91676 9.83825 1.81895 9.95713C1.72115 10.076 1.65434 10.2173 1.62449 10.3683C1.59156 10.5264 1.59845 10.6903 1.64456 10.8451C1.69067 10.9999 1.77455 11.1409 1.88864 11.2552L5.05538 14.422C5.21159 14.5781 5.41736 14.6748 5.63723 14.6954C5.8571 14.7161 6.07729 14.6594 6.25985 14.5352L13.9747 9.22811C14.0052 9.20737 14.0419 9.19791 14.0786 9.20136C14.1152 9.2048 14.1495 9.22094 14.1756 9.24698C14.2016 9.27302 14.2177 9.30733 14.2212 9.344C14.2246 9.38066 14.2152 9.41738 14.1944 9.44781L8.88766 17.1624C8.76337 17.3449 8.70659 17.5649 8.7271 17.7847C8.74761 18.0045 8.84413 18.2103 9.00003 18.3666L12.1673 21.5339C12.2763 21.6431 12.4107 21.7234 12.5584 21.7678C12.7062 21.8122 12.8626 21.8192 13.0137 21.7883C13.196 21.7515 13.3634 21.6619 13.4951 21.5305C13.5864 21.4391 13.6585 21.3302 13.7072 21.2105L20.7216 4.34956L20.7244 4.34174C20.8161 4.11199 20.8383 3.86042 20.7885 3.61814C20.7386 3.37587 20.6188 3.15353 20.4439 2.97863C20.269 2.80373 20.0467 2.68394 19.8044 2.63409C19.5621 2.58423 19.3106 2.6065 19.0808 2.69813Z" />
          </g>
          <defs>
            <clipPath id="clip0_1190_36067">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'lockClosed':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.25 9.75V5.25C8.25 4.25544 8.64509 3.30161 9.34835 2.59835C10.0516 1.89509 11.0054 1.5 12 1.5C12.9946 1.5 13.9484 1.89509 14.6517 2.59835C15.3549 3.30161 15.75 4.25544 15.75 5.25V9.75"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.25 9.75H6.75C5.50736 9.75 4.5 10.7574 4.5 12V20.25C4.5 21.4926 5.50736 22.5 6.75 22.5H17.25C18.4926 22.5 19.5 21.4926 19.5 20.25V12C19.5 10.7574 18.4926 9.75 17.25 9.75Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'downloadApp':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.4375 1.75H8.5625C7.42341 1.75 6.5 2.66782 6.5 3.8V20.2C6.5 21.3322 7.42341 22.25 8.5625 22.25H15.4375C16.5766 22.25 17.5 21.3322 17.5 20.2V3.8C17.5 2.66782 16.5766 1.75 15.4375 1.75Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.75 1.75H9.725C9.8112 1.75 9.89386 1.78951 9.95481 1.85983C10.0158 1.93016 10.05 2.02554 10.05 2.125C10.05 2.32391 10.1185 2.51468 10.2404 2.65533C10.3623 2.79598 10.5276 2.875 10.7 2.875H13.3C13.4724 2.875 13.6377 2.79598 13.7596 2.65533C13.8815 2.51468 13.95 2.32391 13.95 2.125C13.95 2.02554 13.9842 1.93016 14.0452 1.85983C14.1061 1.78951 14.1888 1.75 14.275 1.75H15.25"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'people':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M20.1912 7.6C20.1912 4.50721 17.6559 2 14.5285 2C12.7695 2 11.1978 2.79312 10.1592 4.03748C10.5 4.03 11.5 4.27 12.0001 4.47758C12.6927 3.92846 13.5718 3.6 14.5285 3.6C16.7624 3.6 18.5733 5.39086 18.5733 7.6C18.5733 9.25746 17.5539 10.6795 16.1013 11.2863C16 12 16 12.5 15.5827 13.2444C15.7677 13.261 15.9397 13.2815 16.1013 13.3049C17.8855 13.5632 19.3823 15.3584 19.3823 17.2C19.3823 17.6418 19.7444 18 20.1912 18C20.638 18 21.0002 17.6418 21.0002 17.2C21.0002 15.1256 19.6857 13.0879 17.7974 12.1733C19.2458 11.1589 20.1912 9.48865 20.1912 7.6Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.4717 16.2C8.83899 16.2 8.33169 16.2422 7.89887 16.3049C6.1147 16.5632 4.61792 18.3584 4.61792 20.2C4.61792 20.6418 4.25574 21 3.80896 21C3.36218 21 3 20.6418 3 20.2C3 18.1256 4.31451 16.0879 6.20276 15.1733C4.75439 14.1589 3.80896 12.4887 3.80896 10.6C3.80896 7.50721 6.34426 5 9.4717 5C12.5991 5 15.1344 7.50721 15.1344 10.6C15.1344 12.4887 14.189 14.1589 12.7406 15.1733C14.6289 16.0879 15.9434 18.1256 15.9434 20.2C15.9434 20.6418 15.5812 21 15.1344 21C14.6877 21 14.3255 20.6418 14.3255 20.2C14.3255 18.3584 12.8287 16.5632 11.0445 16.3049C10.6117 16.2422 10.1044 16.2 9.4717 16.2ZM9.4717 14.6C7.23781 14.6 5.42689 12.8091 5.42689 10.6C5.42689 8.39086 7.23781 6.6 9.4717 6.6C11.7056 6.6 13.5165 8.39086 13.5165 10.6C13.5165 12.8091 11.7056 14.6 9.4717 14.6Z"
          />
        </svg>
      );
    case 'calendar':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M8.78571 2.875H15.2143V1.07812C15.2143 0.48291 15.692 0 16.2857 0C16.8795 0 17.3571 0.48291 17.3571 1.07812V2.875H19.1429C20.7188 2.875 22 4.16201 22 5.75V20.125C22 21.7107 20.7188 23 19.1429 23H4.85714C3.27902 23 2 21.7107 2 20.125V5.75C2 4.16201 3.27902 2.875 4.85714 2.875H6.64286V1.07812C6.64286 0.48291 7.12054 0 7.71429 0C8.30804 0 8.78571 0.48291 8.78571 1.07812V2.875ZM4.14286 20.125C4.14286 20.5203 4.4625 20.8438 4.85714 20.8438H19.1429C19.5357 20.8438 19.8571 20.5203 19.8571 20.125V8.625H4.14286V20.125Z" />
        </svg>
      );
    case 'bills':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.129 4.12993L16 4.25348L15.4506 4.77972C15.0679 5.14618 14.4666 5.15042 14.0788 4.78938L12.3271 3.15822C12.1407 2.98474 11.8542 2.97903 11.6611 3.14495L9.71343 4.81905C9.31247 5.16368 8.71314 5.13638 8.34505 4.75672L8 4.40083L7.84757 4.2436L7.19708 3.57267L6.85864 3.22359C6.54581 2.90094 6 3.12284 6 3.57267V4.05934V4.99472V5.21392V16.3692V16.8536V17.9288V18.2782C6 18.7684 6.63021 18.9669 6.91011 18.5648L7.10959 18.2782L7.72346 17.3963L8 16.999L8.07396 16.8928C8.43412 16.3753 9.17616 16.3161 9.61352 16.7699L11.6116 18.8431C11.8188 19.058 12.1664 19.0447 12.3565 18.8145L13.9923 16.8344C14.3944 16.3477 15.1403 16.3508 15.5383 16.8409L16 17.4095L16.2155 17.6748L16.8554 18.4628L17.1122 18.779C17.4092 19.1447 18 18.9343 18 18.4628V18.0552V17.0393V16.6972V5.11013V4.93133V4.03399V3.50989C18 3.06899 17.4726 2.84309 17.1545 3.14774L16.7764 3.50989L16.129 4.12993ZM20 3.50989V18.4628C20 20.8202 17.0458 21.8724 15.5608 20.0437L14.756 19.0527L13.8972 20.0923C12.9466 21.243 11.2086 21.3096 10.173 20.2351L9.01912 19.0379L8.55055 19.7111C7.15102 21.7217 4 20.7295 4 18.2782V3.57267C4 1.3235 6.72907 0.214005 8.2932 1.82729L9.12465 2.68488L10.3589 1.62399C11.3241 0.794396 12.757 0.822937 13.6885 1.69031L14.7499 2.6786L15.7725 1.69916C17.363 0.175903 20 1.30539 20 3.50989ZM8 8.85071C8 8.29734 8.44772 7.84875 9 7.84875H15C15.5523 7.84875 16 8.29734 16 8.85071C16 9.40408 15.5523 9.85267 15 9.85267H9C8.44772 9.85267 8 9.40408 8 8.85071ZM9 11.8566C8.44772 11.8566 8 12.3052 8 12.8585C8 13.4119 8.44772 13.8605 9 13.8605H15C15.5523 13.8605 16 13.4119 16 12.8585C16 12.3052 15.5523 11.8566 15 11.8566H9Z"
          />
        </svg>
      );
    case 'bankTransfer':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.6489 3.06367C11.8753 2.97878 12.1247 2.97878 12.3511 3.06367L20.3511 6.06367C20.7414 6.21003 21 6.58316 21 7V10C21 10.5523 20.5523 11 20 11H19L19 15L19 19H20C20.5523 19 21 19.4477 21 20C21 20.5523 20.5523 21 20 21H18H14L9.99999 21L6 21H4C3.44772 21 3 20.5523 3 20C3 19.4477 3.44772 19 4 19H5L5.00001 15L5.00001 11H4C3.44772 11 3 10.5523 3 10V7C3 6.58316 3.25857 6.21003 3.64888 6.06367L11.6489 3.06367ZM7.00001 11L7.00001 15L7 19H9L9 15L9.00001 11H7.00001ZM11 11L11 15L11 19H13L13 15L13 11H11ZM15 11L15 15L15 19H17L17 15L17 11H15ZM18 9H14L5 9V7.693L12 5.068L19 7.693V9L18 9Z"
          />
        </svg>
      );
    case 'store':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M22.4959 5.81685L20.179 2.13216C19.9728 1.8031 19.6048 1.59998 19.2126 1.59998H4.78579C4.39358 1.59998 4.02563 1.8031 3.81942 2.13216L1.49851 5.81685C0.301667 7.7181 1.36104 10.3628 3.59703 10.6675C3.75877 10.6878 3.92455 10.7 4.08628 10.7C5.14161 10.7 6.07968 10.2369 6.72258 9.52185C7.36548 10.2369 8.30355 10.7 9.35887 10.7C10.4142 10.7 11.3523 10.2369 11.9952 9.52185C12.6381 10.2369 13.5761 10.7 14.6315 10.7C15.6908 10.7 16.6249 10.2369 17.2678 9.52185C17.9147 10.2369 18.8487 10.7 19.904 10.7C20.0698 10.7 20.2316 10.6878 20.3933 10.6675C22.6374 10.3669 23.7008 7.72216 22.4999 5.81685H22.4959ZM20.5591 11.9553H20.555C20.3407 11.9837 20.1224 12 19.9 12C19.3986 12 18.9175 11.9228 18.4686 11.7847V17.2H5.52978V11.7806C5.07692 11.9228 4.59171 12 4.09033 12C3.86794 12 3.64555 11.9837 3.43125 11.9553H3.42721C3.26143 11.9309 3.0997 11.9025 2.942 11.8619V17.2V19.8C2.942 21.234 4.10246 22.4 5.52978 22.4H18.4686C19.896 22.4 21.0564 21.234 21.0564 19.8V17.2V11.8619C20.8947 11.9025 20.7329 11.935 20.5591 11.9553Z" />
        </svg>
      );
    case 'gift':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.5479 2.14924C15.0668 1.86369 14.4315 2.00048 14.1291 2.45478L12.0003 5.65269L9.87143 2.45468C9.56901 2.00038 8.9338 1.86357 8.45266 2.14912C7.97151 2.43466 7.82662 3.03443 8.12903 3.48873L9.78492 5.97628H5C3.89543 5.97628 3 6.87304 3 7.97924V9.98221C3 10.7236 3.4022 11.3709 4 11.7172V11.9852V18.9956C4 20.6549 5.34314 22 7 22H17C18.6569 22 20 20.6549 20 18.9956V11.9852V11.7172C20.5978 11.3709 21 10.7236 21 9.98221V7.97924C21 6.87304 20.1046 5.97628 19 5.97628H14.2156L15.8715 3.48886C16.1739 3.03457 16.029 2.4348 15.5479 2.14924ZM5 9.98221H6H7H11V7.97924H7H5V9.98221ZM13 7.97924V9.98221H17H18H19V7.97924H17H13ZM11 11.9852H8H6V13.9881V18.9956C6 19.5487 6.44772 19.997 7 19.997H11V11.9852ZM13 19.997V11.9852H16H18V13.9881V18.9956C18 19.5487 17.5523 19.997 17 19.997H13Z"
          />
        </svg>
      );
    case 'earth':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_478_7438)">
            <path d="M11.9998 23.2119C8.72089 23.2119 5.61928 21.7847 3.48623 19.2949C2.63196 18.3 1.96786 17.1775 1.50691 15.9561C1.0303 14.6929 0.788086 13.3621 0.788086 12C0.788086 11.3932 0.837571 10.7837 0.933932 10.1952C1.1553 8.81484 1.6319 7.49957 2.34811 6.29113C4.0123 3.48621 6.79903 1.54589 9.98926 0.967788C10.6534 0.847987 11.3305 0.788086 11.9999 0.788086C12.8698 0.788086 13.7318 0.887052 14.5626 1.08238C16.4143 1.51471 18.141 2.42627 19.5554 3.71543C20.9618 4.99679 22.0244 6.62194 22.6286 8.41639C23.0166 9.56754 23.212 10.7708 23.212 12C23.212 13.5132 22.9151 14.9821 22.3317 16.365C21.7666 17.7011 20.9592 18.8991 19.9278 19.9278C18.8991 20.9566 17.6985 21.7665 16.365 22.3317C14.9821 22.9151 13.5132 23.212 12.0001 23.212L11.9998 23.2119ZM11.9998 1.82996C11.393 1.82996 10.7784 1.88465 10.1742 1.99404C7.27809 2.51751 4.75177 4.2781 3.24402 6.82257C2.59553 7.91901 2.16321 9.10926 1.96005 10.3619C1.8741 10.8985 1.82983 11.448 1.82983 12.0001C1.82983 14.4274 2.69971 16.7767 4.27795 18.6178C6.21303 20.8759 9.02575 22.1703 12.0001 22.1703C17.6072 22.1703 22.17 17.6074 22.17 12.0003C22.17 10.8856 21.9929 9.79175 21.6387 8.74999C20.5214 5.43978 17.7191 2.88993 14.3228 2.09843C13.5702 1.92133 12.7889 1.83018 11.9997 1.83018L11.9998 1.82996Z" />
            <path d="M11.9999 21.2326C10.3044 21.2326 8.64799 20.7691 7.20801 19.894L7.74972 19.0033C9.02588 19.7794 10.4948 20.1909 12.0001 20.1909L11.9999 21.2326Z" />
            <path d="M6.22825 19.2063C5.92613 18.9641 5.64486 18.7063 5.38965 18.4433L6.1371 17.7192C6.36107 17.951 6.61371 18.1776 6.88197 18.3938L6.22825 19.2063Z" />
            <path d="M13.9482 21.0165C13.4482 21.0165 13.0002 20.7196 12.8075 20.2508L12.0913 18.498C12.0001 18.2688 11.9767 18.0266 12.0262 17.7922L12.1772 17.0448C12.1851 17.0057 12.1798 16.9693 12.1642 16.9328L11.3777 15.0993C11.349 15.0316 11.2865 14.9899 11.211 14.9847L9.70566 14.8883C9.56242 14.8805 9.41658 14.8441 9.28635 14.7842L7.92685 14.1825C7.59088 14.0367 7.33828 13.7502 7.23927 13.396L6.75484 11.7135C6.64285 11.3307 6.72619 10.914 6.97882 10.5989L6.98142 10.5963L8.81492 8.33826C9.02067 8.08302 9.3254 7.91895 9.65095 7.8877L9.71866 7.87988L11.6694 8.19502C11.9767 8.18199 12.2736 8.28357 12.5132 8.4841L13.3961 9.22898C13.4221 9.24982 13.4508 9.26544 13.4846 9.27065L15.3416 8.60654L15.4119 8.60134C15.8651 8.56487 16.3 8.78104 16.5474 9.16386L16.5735 9.20293L17.498 11.4427C17.5423 11.4896 17.61 11.5156 17.6751 11.5026C18.0658 11.4323 18.4539 11.5469 18.7429 11.8177C19.032 12.0886 19.1701 12.4662 19.1258 12.8569L19.045 13.5627C19.0216 13.7866 18.9357 14.0028 18.795 14.1825L17.5579 15.7816C17.5319 15.8155 17.5188 15.8598 17.5214 15.904L17.5892 17.0917C17.6126 17.5084 17.4277 17.9042 17.0943 18.1517L16.4744 18.6126C16.4692 18.6178 16.4614 18.6231 16.4562 18.6257L15.7661 20.3602L15.7322 20.4097C15.5265 20.7092 15.2009 20.9019 14.8363 20.9384L14.0628 21.0139C14.0237 21.0165 13.9873 21.0165 13.9482 21.0165L13.9482 21.0165ZM13.0575 18.11L13.7711 19.8549C13.8024 19.9331 13.8805 19.98 13.9664 19.9721L14.7321 19.8966C14.7764 19.8914 14.8155 19.8732 14.8467 19.8445L15.5317 18.11L15.5629 18.0631C15.6385 17.9537 15.7322 17.8547 15.8416 17.7714L16.464 17.3078C16.5161 17.2688 16.5448 17.2063 16.5422 17.1411L16.4745 15.9587C16.4562 15.6618 16.5474 15.3676 16.7323 15.1331L17.9668 13.5392C17.9876 13.5106 18.0006 13.4819 18.0033 13.4481V13.4403L18.084 12.7319C18.0944 12.6485 18.0501 12.5964 18.0241 12.5704C17.998 12.5444 17.9407 12.5053 17.8548 12.5209C17.3626 12.6121 16.8677 12.3985 16.5943 11.9766L16.5682 11.9375L15.6437 9.69774C15.615 9.66649 15.5759 9.64305 15.5343 9.63784L13.6825 10.3072L13.6148 10.3124C13.2867 10.3384 12.969 10.2369 12.7189 10.0233L11.8387 9.28105C11.7996 9.24719 11.7475 9.23157 11.698 9.23678L11.6277 9.24459L9.70567 8.93206C9.67442 8.94248 9.64577 8.96331 9.62233 8.99196L7.79146 11.2474C7.75239 11.2994 7.73937 11.3619 7.755 11.4219L8.23942 13.1095C8.25505 13.1616 8.29151 13.2059 8.34099 13.2267L8.34359 13.2293L9.70829 13.831C9.72652 13.8388 9.74996 13.844 9.77079 13.8466L11.2787 13.9429C11.7449 13.9742 12.1486 14.2607 12.3335 14.6852L13.12 16.5161C13.219 16.7453 13.2451 16.9979 13.1956 17.2453L13.0445 17.998C13.0393 18.037 13.0445 18.0735 13.0575 18.11H13.0575Z" />
            <path d="M4.36131 19.1596L3.40289 18.7533L3.66594 18.1361L3.97065 16.576L4.26755 15.3077L3.26746 14.443L2.31947 12.9585L0.991211 10.5286L1.90277 10.0286L3.22322 12.4428L4.06444 13.7554L5.42394 14.9326L4.98901 16.8026L4.66606 18.4434L4.36131 19.1596Z" />
            <path d="M2.97274 7.11662C2.92847 7.11662 2.8868 7.11141 2.84252 7.1036L2.83471 7.10099C2.63417 7.05411 2.47009 6.91348 2.38935 6.72596C2.31122 6.53844 2.32945 6.32228 2.43623 6.14776L2.97795 6.48113L3.06389 6.08526C2.93628 6.05661 2.80345 6.09307 2.7097 6.17902L2.78002 6.11391L4.56403 5.41594C4.68904 5.34302 4.83489 5.31437 4.97553 5.3326L5.59539 5.41594L6.1163 4.76745L6.77783 3.48348L6.80908 3.44181C6.89242 3.33763 6.98879 3.28815 7.02265 3.27252L7.04869 3.2595L7.60083 3.0199C7.85086 2.91051 8.14255 2.97302 8.32747 3.17876C8.43165 3.29335 8.48634 3.43921 8.49155 3.58765L9.7729 3.18137L10.6245 2.37401L9.87448 1.95991C9.95782 2.00418 10.0568 2.01981 10.1505 2.00158L9.9422 0.978059C10.088 0.94941 10.2417 0.97285 10.3719 1.04577L11.6116 1.73074C11.8069 1.83752 11.9319 2.04327 11.9398 2.26465C11.9476 2.46518 11.8564 2.65791 11.7028 2.78031L10.3745 4.04086L10.338 4.0643C10.3042 4.08513 10.2521 4.11639 10.187 4.13722L10.1792 4.13982L8.33266 4.72583L8.31704 4.73104C8.26234 4.74406 8.20765 4.75187 8.15556 4.75187H7.8196C7.65552 4.75187 7.49665 4.68676 7.37945 4.57737L6.97317 5.36649L6.9315 5.40816L6.25434 6.252C6.11371 6.42129 5.89754 6.50463 5.68139 6.47598L4.95218 6.37701L3.30098 7.0255C3.20202 7.0854 3.08742 7.11666 2.97283 7.11666L2.97274 7.11662ZM2.97795 6.48113L3.32173 6.69209C3.38945 6.5801 3.39987 6.44207 3.35038 6.32227C3.3009 6.20247 3.19412 6.11391 3.06911 6.08266L2.97795 6.48113Z" />
            <path d="M17.3729 12.6096C17.1463 12.6096 16.9328 12.495 16.8078 12.3022L16.7869 12.271L15.4457 9.37492C15.3832 9.26033 15.3571 9.1301 15.3675 8.99988V8.98947L15.404 8.62225L14.9873 8.67694C14.9795 8.67694 14.9717 8.67954 14.9639 8.67954H14.956C14.9404 8.68215 14.9222 8.68215 14.9013 8.68215H14.0236C13.9169 8.68215 13.8335 8.6561 13.7814 8.63527L13.7632 8.62745L12.7241 8.18991L12.7084 8.1821C12.6772 8.16647 12.6095 8.13261 12.5418 8.06751L11.974 7.56484L11.5208 7.67163L10.6666 8.69777L10.5051 8.85924L9.54406 8.94779C9.29924 8.97123 9.05963 8.85663 8.92162 8.65089L8.91902 8.64568L8.71327 8.33054C8.61951 8.1873 8.58305 8.0128 8.61691 7.84093L8.81745 6.70282C8.87474 6.36425 9.17946 6.12463 9.52584 6.14811L9.65867 6.15852C9.63523 6.03091 9.64825 5.89548 9.69773 5.77567C9.76805 5.60639 9.90609 5.47356 10.078 5.40585L11.1327 4.99696L10.9921 4.73392C10.8437 4.45785 10.9088 4.10886 11.1484 3.9057L11.151 3.9031L12.5313 2.7337C12.7214 2.56963 12.9844 2.52535 13.2162 2.61911L13.9976 2.93164L14.2919 2.64776L14.0601 2.05395C13.9663 1.81434 14.0184 1.54609 14.1903 1.35598C14.3622 1.16846 14.6226 1.09293 14.8674 1.16325L14.5836 2.16596C14.719 2.20503 14.8674 2.16075 14.9612 2.05918C15.055 1.95761 15.081 1.80655 15.0315 1.67894L15.3545 2.51235C15.4456 2.76497 15.3805 3.04625 15.1878 3.23117L14.5471 3.84842C14.357 4.03333 14.0705 4.09063 13.8257 3.98906L13.0392 3.66611L12.0521 4.50214L12.2474 4.86936C12.3386 5.03344 12.3542 5.22877 12.2917 5.40588C12.2266 5.5908 12.0885 5.73664 11.9062 5.80957L11.8984 5.81217L10.8202 6.22888L10.8436 6.27576C10.9348 6.46848 10.927 6.68465 10.8332 6.86957C10.9217 6.78102 11.0337 6.71331 11.1561 6.68466L11.164 6.68206L11.9349 6.49975C12.1484 6.45287 12.3724 6.51277 12.5339 6.66122L13.1954 7.26285L14.0939 7.64049H14.8622L15.7217 7.5259C15.93 7.49725 16.1332 7.56496 16.2816 7.71081C16.4275 7.85405 16.5004 8.05459 16.4796 8.25771L16.4093 8.98435L17.5838 11.5184L18.3469 11.3778L18.9199 10.1121L18.7922 9.58597C18.748 9.40367 18.7818 9.20833 18.8886 9.05207C18.9954 8.89581 19.1621 8.78903 19.3496 8.76038H19.3548L19.8783 8.69005C20.1387 8.6562 20.3966 8.776 20.5346 8.99477L21.2456 10.1094L21.2534 10.1355C21.256 10.1407 21.2586 10.1485 21.2612 10.1563L21.3524 10.3673L21.6102 8.53116L22.0269 8.59106L22.6129 8.39573C22.6364 8.46605 22.6468 8.53376 22.6468 8.60408V8.64054L22.2066 11.7658C22.1936 11.9455 22.1103 12.1148 21.9748 12.2294C21.8134 12.3674 21.5946 12.4221 21.3863 12.3753C21.1779 12.3284 21.0034 12.1825 20.9175 11.9846L20.3106 10.586L19.9669 10.0495C19.9877 10.1823 19.9669 10.3126 19.9096 10.4324L19.2064 11.9872C19.1126 12.1851 18.9303 12.3257 18.7167 12.3648L17.4771 12.594C17.4484 12.607 17.4093 12.6096 17.3729 12.6096L17.3729 12.6096ZM21.6129 8.60658C21.6129 8.66127 21.6259 8.70554 21.6311 8.72638L21.9931 8.60658H21.6129ZM9.66655 7.88256L9.67176 7.89037L10.0103 7.85912L10.6406 7.10124C10.513 7.1976 10.3515 7.24709 10.1874 7.23667L9.78634 7.20802L9.66655 7.88256Z" />
          </g>
          <defs>
            <clipPath id="clip0_478_7438">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'percent':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill="white"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M6.5 20L17.5 4" stroke="#1743EA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path
            d="M6.50003 9C7.88075 9 9 7.88075 9 6.50003C9 5.11931 7.88075 4 6.50003 4C5.11931 4 4 5.11931 4 6.50003C4 7.88075 5.11931 9 6.50003 9Z"
            stroke="#1743EA"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.5 20C18.8807 20 20 18.8807 20 17.5C20 16.1193 18.8807 15 17.5 15C16.1193 15 15 16.1193 15 17.5C15 18.8807 16.1193 20 17.5 20Z"
            stroke="#1743EA"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'lockOpened':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.75 5.25C15.75 4.25544 15.3549 3.30161 14.6517 2.59835C13.9484 1.89509 12.9946 1.5 12 1.5C11.0054 1.5 10.0516 1.89509 9.34835 2.59835C8.64509 3.30161 8.25 4.25544 8.25 5.25V9.75"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.25 9.75H6.75C5.50736 9.75 4.5 10.7574 4.5 12V20.25C4.5 21.4926 5.50736 22.5 6.75 22.5H17.25C18.4926 22.5 19.5 21.4926 19.5 20.25V12C19.5 10.7574 18.4926 9.75 17.25 9.75Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'transactionLimit':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill="white"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22 8.5C22 12.09 19.09 15 15.5 15C15.33 15 15.15 14.99 14.98 14.98C14.73 11.81 12.19 9.26999 9.01999 9.01999C9.00999 8.84999 9 8.67 9 8.5C9 4.91 11.91 2 15.5 2C19.09 2 22 4.91 22 8.5Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15 15.5C15 19.09 12.09 22 8.5 22C4.91 22 2 19.09 2 15.5C2 11.91 4.91 9 8.5 9C8.67 9 8.84999 9.00999 9.01999 9.01999C12.19 9.26999 14.73 11.81 14.98 14.98C14.99 15.15 15 15.33 15 15.5Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.62 14.62L8.5 13L9.38 14.62L11 15.5L9.38 16.38L8.5 18L7.62 16.38L6 15.5L7.62 14.62Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'congrats':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M22.0815 1C21.59 1.35425 21.0049 1.70554 20.4158 1.83437L20.7516 3.36971C21.6903 3.16462 22.4423 2.67664 23 2.27453L22.0815 1ZM10.2059 1.22998L9.09551 2.34041C10.5227 3.7676 10.227 5.49975 9.94827 6.36952C10.3782 6.55235 10.8484 6.79897 11.3455 7.09503C11.7223 6.01265 12.3371 3.36109 10.2059 1.23011V1.22998ZM14.2505 1.38195L12.9039 2.18877C13.9551 3.94075 13.7637 5.39442 13.3349 6.50938C13.0874 7.15304 12.7979 7.59105 12.5649 7.89587C12.9576 8.18948 13.3614 8.51988 13.7751 8.8943C14.0839 8.49114 14.4906 7.88115 14.8012 7.07379C15.354 5.63646 15.5553 3.5565 14.2506 1.38208L14.2505 1.38195ZM17.6277 2.14726C17.109 2.95601 16.922 3.83193 16.8117 4.51082L18.3623 4.76253C18.4594 4.16464 18.6243 3.5015 18.9497 2.99408L17.6277 2.14726ZM19.8515 5.61968C19.428 5.60478 19.0342 5.6316 18.692 5.66718L18.8499 7.23003C19.4526 7.16885 20.1344 7.15763 20.7088 7.34045L21.1858 5.84353C20.7281 5.69787 20.275 5.63582 19.8514 5.61969L19.8515 5.61968ZM6.74552 7.28228L1 23L2.58738 22.4203L16.7178 17.2545V16.7054C16.7178 16.7054 16.7014 15.9255 16.2684 14.8435C15.8356 13.7613 14.9865 12.2933 13.3466 10.6533C11.7066 9.0133 10.2386 8.16439 9.1564 7.73146C8.0742 7.2985 7.29454 7.28201 7.29454 7.28201L6.74552 7.28228ZM19.497 8.77763C18.5254 8.73398 17.6451 8.92312 16.9265 9.19936C16.1191 9.50997 15.5091 9.91644 15.106 10.2255C15.4804 10.6392 15.811 11.043 16.1044 11.4357C16.4092 11.2031 16.8473 10.9133 17.4909 10.6658C18.6057 10.2371 20.0595 10.0457 21.8115 11.0968L22.6182 9.75012C21.5309 9.0977 20.4685 8.82129 19.497 8.77762V8.77763ZM8.33132 9.10734C8.41143 9.13399 8.44771 9.13819 8.57374 9.18868C9.45473 9.54118 10.7352 10.2627 12.2363 11.7638C13.7374 13.265 14.4591 14.5454 14.8114 15.4264C14.8619 15.5523 14.8661 15.5887 14.8928 15.6688C14.8111 15.6392 14.7457 15.6213 14.6535 15.5845C13.7725 15.232 12.4921 14.5105 10.9909 13.0094C9.4898 11.5082 8.76815 10.2278 8.41581 9.34678C8.379 9.25476 8.36059 9.1892 8.3315 9.10752L8.33132 9.10734ZM7.23315 10.523C7.68484 11.4562 8.45329 12.5999 9.65031 13.8511V18.1656L6.50922 19.3142V12.5029L7.23315 10.523ZM19.0338 12.2821C18.8668 12.2833 18.7036 12.2911 18.546 12.3058C17.8359 12.3663 17.295 12.5195 16.905 12.6555C17.2011 13.1526 17.4477 13.6227 17.6305 14.0527C18.5003 13.774 20.2324 13.4783 21.6596 14.9055L22.77 13.795C21.5774 12.6024 20.203 12.2741 19.0338 12.2827V12.2821Z" />
        </svg>
      );
    case 'collapse':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.33496 14.625H10.585V19.875M10.1054 15.1031L4.58496 20.625M19.335 11.125H14.085V5.875M14.5645 10.6469L20.085 5.125"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'overview':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M15.75 9H8.25" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M15.75 15H8.25" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'addFilter':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_247_2817)">
            <path d="M4.97776 6H15.0323L9.99497 12.3L4.97776 6ZM2.21276 5.61C4.24378 8.2 7.99412 13 7.99412 13V19C7.99412 19.55 8.44657 20 8.99957 20H11.0105C11.5635 20 12.0159 19.55 12.0159 19V13C12.0159 13 15.7562 8.2 17.7872 5.61C18.3 4.95 17.8275 4 16.9929 4H3.00707C2.17254 4 1.69998 4.95 2.21276 5.61Z" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.75 10C19.3358 10 19 10.3358 19 10.75V13.25H16.5C16.0858 13.25 15.75 13.5858 15.75 14C15.75 14.4142 16.0858 14.75 16.5 14.75H19V17.25C19 17.6642 19.3358 18 19.75 18C20.1642 18 20.5 17.6642 20.5 17.25V14.75H23C23.4142 14.75 23.75 14.4142 23.75 14C23.75 13.5858 23.4142 13.25 23 13.25H20.5V10.75C20.5 10.3358 20.1642 10 19.75 10Z"
            />
          </g>
          <defs>
            <clipPath id="clip0_247_2817">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'transactions':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill="white"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.47 11.4199L2.73 9.67993L1 11.4199"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.5298 12.5801L21.2698 14.3201L23.0098 12.5801"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.26 14.32V12C21.26 6.88 17.11 2.73999 12 2.73999C9.08002 2.73999 6.47002 4.10002 4.77002 6.21002"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.74023 9.67993V11.9999C2.74023 17.1199 6.89024 21.2599 12.0002 21.2599C14.9202 21.2599 17.5302 19.8999 19.2302 17.7899"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 8.5H13.38C14.35 8.5 15.13 9.38 15.13 10.25C15.13 11.22 14.35 12 13.38 12H9V8.5Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 12H14C15.1 12 16 12.78 16 13.75C16 14.72 15.1 15.5 14 15.5H9V12Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.7998 15.5V17.25"
            stroke={stroke}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.7998 6.75V8.5"
            stroke={stroke}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'expand':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.335 4.625H20.585V9.875M20.1054 5.10312L14.585 10.625M9.33496 21.125H4.08496V15.875M4.56449 20.6469L10.085 15.125"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'hide':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M20.25 21C20.1515 21.0001 20.0539 20.9808 19.9629 20.9431C19.8719 20.9053 19.7893 20.85 19.7198 20.7801L3.2198 4.28013C3.08509 4.13833 3.01109 3.94952 3.0136 3.75395C3.0161 3.55838 3.0949 3.37152 3.23321 3.23322C3.37151 3.09492 3.55836 3.01612 3.75393 3.01361C3.94951 3.01111 4.13832 3.0851 4.28011 3.21982L20.7801 19.7198C20.8849 19.8247 20.9563 19.9583 20.9852 20.1038C21.0141 20.2492 20.9993 20.3999 20.9425 20.5369C20.8858 20.6739 20.7897 20.791 20.6665 20.8735C20.5432 20.9559 20.3982 20.9999 20.25 21ZM11.984 18C10.0392 18 8.16371 17.4243 6.40965 16.289C4.81261 15.2578 3.37496 13.7808 2.25183 12.0234V12.0197C3.18652 10.6804 4.21027 9.54794 5.30996 8.63482C5.31991 8.6265 5.32802 8.61621 5.33379 8.6046C5.33956 8.59298 5.34285 8.5803 5.34347 8.56735C5.34409 8.5544 5.34201 8.54146 5.33737 8.52935C5.33273 8.51724 5.32563 8.50623 5.31652 8.497L4.38277 7.56466C4.36618 7.54793 4.34389 7.53806 4.32035 7.53702C4.29682 7.53598 4.27375 7.54384 4.25574 7.55903C3.08761 8.54341 2.0034 9.75091 1.01761 11.1647C0.848014 11.4081 0.754608 11.6964 0.749266 11.9931C0.743924 12.2897 0.826888 12.5812 0.987615 12.8306C2.22558 14.7679 3.81886 16.3997 5.59449 17.5486C7.59371 18.8437 9.74527 19.5 11.984 19.5C13.1924 19.4962 14.3923 19.2971 15.5371 18.9103C15.5522 18.9052 15.5658 18.8963 15.5765 18.8845C15.5872 18.8726 15.5947 18.8583 15.5983 18.8427C15.602 18.8272 15.6015 18.811 15.5972 18.7957C15.5928 18.7803 15.5845 18.7664 15.5732 18.7551L14.5617 17.7436C14.5384 17.7208 14.5096 17.7046 14.4781 17.6964C14.4466 17.6881 14.4136 17.6883 14.3821 17.6967C13.5987 17.8984 12.793 18.0003 11.984 18ZM23.0081 11.1843C21.7678 9.26622 20.1586 7.63685 18.3548 6.472C16.3593 5.182 14.1562 4.49997 11.984 4.49997C10.7884 4.50209 9.60169 4.7054 8.47355 5.10138C8.45852 5.10661 8.44507 5.11558 8.43446 5.12745C8.42386 5.13931 8.41645 5.15368 8.41293 5.1692C8.40941 5.18473 8.40991 5.20089 8.41436 5.21616C8.41882 5.23144 8.42709 5.24534 8.4384 5.25653L9.44855 6.26669C9.47207 6.28981 9.50127 6.30631 9.5332 6.31454C9.56513 6.32277 9.59867 6.32244 9.63043 6.31357C10.3978 6.10599 11.1891 6.00055 11.984 5.99997C13.8914 5.99997 15.7612 6.58263 17.5411 7.73435C19.1681 8.78435 20.6226 10.26 21.7486 12C21.7494 12.001 21.7498 12.0024 21.7498 12.0037C21.7498 12.0051 21.7494 12.0064 21.7486 12.0075C20.9312 13.2942 19.917 14.4446 18.7429 15.4167C18.7329 15.425 18.7247 15.4353 18.7188 15.4469C18.7129 15.4585 18.7096 15.4713 18.7089 15.4843C18.7083 15.4973 18.7103 15.5103 18.715 15.5225C18.7196 15.5346 18.7267 15.5457 18.7359 15.555L19.6687 16.4873C19.6852 16.504 19.7074 16.5139 19.7308 16.515C19.7542 16.5161 19.7772 16.5084 19.7953 16.4934C21.0487 15.438 22.1337 14.1975 23.0128 12.8147C23.1682 12.571 23.2503 12.2878 23.2495 11.9988C23.2486 11.7098 23.1649 11.4271 23.0081 11.1843Z" />
          <path d="M12 7.5C11.6629 7.49982 11.3269 7.53756 10.9983 7.6125C10.9817 7.61595 10.9663 7.62383 10.9538 7.63531C10.9414 7.64679 10.9322 7.66144 10.9274 7.6777C10.9226 7.69395 10.9223 7.71121 10.9265 7.72763C10.9307 7.74405 10.9393 7.75901 10.9514 7.77094L16.229 13.0472C16.241 13.0592 16.2559 13.0678 16.2723 13.0721C16.2888 13.0763 16.306 13.076 16.3223 13.0712C16.3385 13.0663 16.3532 13.0572 16.3647 13.0447C16.3761 13.0323 16.384 13.0169 16.3875 13.0003C16.5377 12.3413 16.5376 11.6568 16.3871 10.9979C16.2365 10.3389 15.9395 9.72228 15.5179 9.19385C15.0964 8.66542 14.5613 8.23874 13.9522 7.9455C13.3432 7.65226 12.6759 7.49999 12 7.5ZM7.77091 10.9528C7.75899 10.9408 7.74402 10.9322 7.7276 10.9279C7.71118 10.9237 7.69392 10.924 7.67767 10.9289C7.66141 10.9337 7.64676 10.9428 7.63528 10.9553C7.6238 10.9677 7.61592 10.9831 7.61247 10.9997C7.44248 11.7424 7.46382 12.516 7.67451 13.2482C7.88519 13.9803 8.27832 14.647 8.81704 15.1857C9.35577 15.7245 10.0224 16.1176 10.7546 16.3283C11.4868 16.539 12.2604 16.5603 13.0031 16.3903C13.0197 16.3869 13.035 16.379 13.0475 16.3675C13.06 16.356 13.0691 16.3414 13.0739 16.3251C13.0787 16.3089 13.0791 16.2916 13.0748 16.2752C13.0706 16.2588 13.062 16.2438 13.05 16.2319L7.77091 10.9528Z" />
        </svg>
      );
    case 'multiply':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M17.7338 6.27531C17.3788 5.92036 16.8055 5.92036 16.4505 6.27531L12 10.7167L7.54949 6.26621C7.19454 5.91126 6.62116 5.91126 6.26621 6.26621C5.91126 6.62116 5.91126 7.19454 6.26621 7.54949L10.7167 12L6.26621 16.4505C5.91126 16.8055 5.91126 17.3788 6.26621 17.7338C6.62116 18.0887 7.19454 18.0887 7.54949 17.7338L12 13.2833L16.4505 17.7338C16.8055 18.0887 17.3788 18.0887 17.7338 17.7338C18.0887 17.3788 18.0887 16.8055 17.7338 16.4505L13.2833 12L17.7338 7.54949C18.0796 7.20364 18.0796 6.62116 17.7338 6.27531Z" />
        </svg>
      );
    case 'equal':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_140_2286)">
            <path d="M18 10H6C5.45 10 5 9.55 5 9C5 8.45 5.45 8 6 8H18C18.55 8 19 8.45 19 9C19 9.55 18.55 10 18 10Z" />
            <path d="M18 16H6C5.45 16 5 15.55 5 15C5 14.45 5.45 14 6 14H18C18.55 14 19 14.45 19 15C19 15.55 18.55 16 18 16Z" />
          </g>
          <defs>
            <clipPath id="clip0_140_2286">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'show':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_146_3611)">
            <path
              d="M12.949 5.39478C9.29551 5.39478 5.54786 7.50931 2.59754 11.7384C2.51333 11.8604 2.46718 12.0047 2.46493 12.1529C2.46268 12.3012 2.50442 12.4468 2.58489 12.5713C4.85176 16.1198 8.54926 18.8948 12.949 18.8948C17.3008 18.8948 21.0743 16.1113 23.3454 12.5549C23.4239 12.4328 23.4657 12.2907 23.4657 12.1455C23.4657 12.0003 23.4239 11.8581 23.3454 11.736C21.0691 8.2204 17.268 5.39478 12.949 5.39478Z"
              stroke={stroke}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12.9648 15.8948C15.0359 15.8948 16.7148 14.2158 16.7148 12.1448C16.7148 10.0737 15.0359 8.39478 12.9648 8.39478C10.8938 8.39478 9.21484 10.0737 9.21484 12.1448C9.21484 14.2158 10.8938 15.8948 12.9648 15.8948Z"
              stroke={stroke}
              strokeWidth="1.5"
              strokeMiterlimit="10"
            />
          </g>
          <defs>
            <clipPath id="clip0_146_3611">
              <rect width="24" height="24" fill="white" transform="translate(0.964844 0.144775)" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'sell':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.8335 6.21667H21.1668"
            stroke={stroke}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.6835 3.25H19.3169C20.8002 3.25 21.1668 3.61667 21.1668 5.08333V8.50833C21.1668 9.975 20.8002 10.3417 19.3169 10.3417H14.6835C13.2001 10.3417 12.8335 9.975 12.8335 8.50833V5.08333C12.8335 3.61667 13.2001 3.25 14.6835 3.25Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.3333 14.5C20.3333 17.725 17.725 20.3333 14.5 20.3333L15.375 18.875"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.6665 9.49996C3.6665 6.27496 6.27484 3.66663 9.49984 3.66663L8.62485 5.12496"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.4165 20.3334C9.48757 20.3334 11.1665 18.6544 11.1665 16.5834C11.1665 14.5123 9.48757 12.8334 7.4165 12.8334C5.34544 12.8334 3.6665 14.5123 3.6665 16.5834C3.6665 18.6544 5.34544 20.3334 7.4165 20.3334Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'bitcoin':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_1174_32570)">
            <path
              d="M23.6383 14.9029C22.0356 21.3315 15.5244 25.2438 9.09503 23.6407C2.66833 22.038 -1.24401 15.5265 0.359382 9.09837C1.96136 2.66903 8.47253 -1.24361 14.8999 0.359081C21.3289 1.96177 25.241 8.47404 23.6381 14.903L23.6382 14.9029H23.6383Z"
              fill="#F7931A"
            />
            <path
              d="M17.291 10.2903C17.5299 8.6934 16.3141 7.83498 14.6516 7.26233L15.1909 5.09914L13.8741 4.77103L13.3491 6.87726C13.0029 6.79092 12.6474 6.70957 12.2941 6.62892L12.8229 4.50878L11.5069 4.18066L10.9673 6.34315C10.6808 6.27793 10.3994 6.21347 10.1265 6.14554L10.128 6.13874L8.31209 5.68528L7.9618 7.09171C7.9618 7.09171 8.93876 7.31565 8.91817 7.32943C9.4514 7.46252 9.54783 7.81551 9.53182 8.09529L8.91747 10.5597C8.95418 10.569 9.00181 10.5825 9.05437 10.6036C9.01043 10.5927 8.96369 10.5808 8.91518 10.5692L8.05407 14.0214C7.9889 14.1834 7.82349 14.4266 7.45068 14.3342C7.46388 14.3534 6.49361 14.0954 6.49361 14.0954L5.83984 15.6027L7.55345 16.0299C7.87224 16.1098 8.18463 16.1935 8.49228 16.2721L7.94737 18.4601L9.26265 18.7883L9.80228 16.6235C10.1616 16.721 10.5103 16.811 10.8517 16.8958L10.3139 19.0504L11.6307 19.3785L12.1756 17.1946C14.421 17.6196 16.1094 17.4482 16.82 15.4172C17.3927 13.7821 16.7915 12.8389 15.6102 12.2238C16.4706 12.0254 17.1187 11.4595 17.2915 10.2905L17.2911 10.2902L17.291 10.2903ZM14.2825 14.5091C13.8755 16.1443 11.1224 15.2604 10.2298 15.0387L10.9529 12.14C11.8454 12.3628 14.7078 12.8038 14.2825 14.5091H14.2825ZM14.6897 10.2666C14.3185 11.754 12.027 10.9984 11.2837 10.8131L11.9392 8.1841C12.6826 8.36939 15.0764 8.71522 14.6898 10.2666H14.6897Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1174_32570">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'ethereum':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_1174_32579)">
            <circle cx="12" cy="12" r="12" fill="#627EEA" />
            <path d="M12.1381 2L12.0039 2.45578V15.6802L12.1381 15.8141L18.2766 12.1856L12.1381 2Z" fill="#C1CCF7" />
            <path d="M12.1387 2L6 12.1856L12.1387 15.8141V9.39532V2Z" fill="white" />
            <path
              d="M12.1381 16.9763L12.0625 17.0685V21.7792L12.1381 22L18.2804 13.3496L12.1381 16.9763Z"
              fill="#C1CCF7"
            />
            <path d="M12.1387 22V16.9763L6 13.3496L12.1387 22Z" fill="white" />
            <path d="M12.1367 15.8143L18.2752 12.1858L12.1367 9.39551V15.8143Z" fill="#8198EE" />
            <path d="M6 12.1858L12.1387 15.8143V9.39551L6 12.1858Z" fill="#C1CCF7" />
          </g>
          <defs>
            <clipPath id="clip0_1174_32579">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'loader':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.9095 2.90909C12.9095 2.40701 12.5025 2 12.0004 2C11.4983 2 11.0913 2.40701 11.0913 2.90909V6.54545C11.0913 7.04753 11.4983 7.45455 12.0004 7.45455C12.5025 7.45455 12.9095 7.04753 12.9095 6.54545V2.90909ZM12.9095 17.4548C12.9095 16.9527 12.5025 16.5457 12.0004 16.5457C11.4983 16.5457 11.0913 16.9527 11.0913 17.4548V21.0911C11.0913 21.5932 11.4983 22.0002 12.0004 22.0002C12.5025 22.0002 12.9095 21.5932 12.9095 21.0911V17.4548ZM4.92996 4.92996C5.28498 4.57493 5.86058 4.57493 6.21561 4.92996L8.78833 7.50268C9.14336 7.85771 9.14336 8.43331 8.78833 8.78833C8.43331 9.14336 7.85771 9.14336 7.50268 8.78833L4.92996 6.21561C4.57493 5.86058 4.57493 5.28498 4.92996 4.92996ZM16.4974 15.2118C16.1424 14.8567 15.5668 14.8567 15.2118 15.2118C14.8567 15.5668 14.8567 16.1424 15.2118 16.4974L17.7845 19.0701C18.1395 19.4252 18.7151 19.4252 19.0701 19.0701C19.4252 18.7151 19.4252 18.1395 19.0701 17.7845L16.4974 15.2118ZM2 12C2 11.4979 2.40701 11.0909 2.90909 11.0909H6.54545C7.04753 11.0909 7.45455 11.4979 7.45455 12C7.45455 12.502 7.04753 12.909 6.54545 12.909H2.90909C2.40701 12.909 2 12.502 2 12ZM17.4543 11.0909C16.9522 11.0909 16.5452 11.4979 16.5452 12C16.5452 12.502 16.9522 12.909 17.4543 12.909H21.0907C21.5927 12.909 21.9997 12.502 21.9997 12C21.9997 11.4979 21.5927 11.0909 21.0907 11.0909H17.4543ZM8.78833 15.2118C9.14336 15.5668 9.14336 16.1424 8.78833 16.4974L6.21561 19.0701C5.86058 19.4252 5.28498 19.4252 4.92996 19.0701C4.57493 18.7151 4.57493 18.1395 4.92996 17.7845L7.50268 15.2118C7.85771 14.8567 8.43331 14.8567 8.78833 15.2118ZM19.0701 6.21561C19.4252 5.86058 19.4252 5.28498 19.0701 4.92996C18.7151 4.57493 18.1395 4.57493 17.7845 4.92996L15.2118 7.50268C14.8567 7.85771 14.8567 8.43331 15.2118 8.78833C15.5668 9.14336 16.1424 9.14336 16.4974 8.78833L19.0701 6.21561Z"
          />
        </svg>
      );
    case 'phone':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M19.4 11.825C19.3167 9.80831 18.575 8.09998 17.175 6.69998C15.775 5.29998 14.0667 4.55831 12.05 4.47498V2.97498C13.25 3.00831 14.3792 3.26248 15.4375 3.73748C16.4958 4.21248 17.425 4.84998 18.225 5.64998C19.025 6.44998 19.6625 7.37914 20.1375 8.43748C20.6125 9.49581 20.8667 10.625 20.9 11.825H19.4ZM15.175 11.825C15.0917 10.9916 14.7583 10.2875 14.175 9.71248C13.5917 9.13748 12.8833 8.80831 12.05 8.72498V7.22498C13.3 7.30831 14.3625 7.78331 15.2375 8.64998C16.1125 9.51664 16.5917 10.575 16.675 11.825H15.175ZM19.875 21C17.8417 21 15.8208 20.5 13.8125 19.5C11.8042 18.5 10 17.2 8.4 15.6C6.8 14 5.5 12.1958 4.5 10.1875C3.5 8.17914 3 6.15831 3 4.12498C3 3.80831 3.10833 3.54164 3.325 3.32498C3.54167 3.10831 3.80833 2.99998 4.125 2.99998H7.625C7.85833 2.99998 8.0625 3.07914 8.2375 3.23748C8.4125 3.39581 8.525 3.60831 8.575 3.87498L9.25 7.02498C9.28333 7.25831 9.27917 7.47081 9.2375 7.66248C9.19583 7.85414 9.10833 8.01664 8.975 8.14998L6.475 10.675C7.40833 12.225 8.45417 13.575 9.6125 14.725C10.7708 15.875 12.0833 16.85 13.55 17.65L15.925 15.2C16.0917 15.0166 16.2833 14.8875 16.5 14.8125C16.7167 14.7375 16.9333 14.725 17.15 14.775L20.125 15.425C20.375 15.475 20.5833 15.6 20.75 15.8C20.9167 16 21 16.2333 21 16.5V19.875C21 20.1916 20.8917 20.4583 20.675 20.675C20.4583 20.8916 20.1917 21 19.875 21ZM5.725 9.29998L7.75 7.24998L7.175 4.49998H4.5C4.5 5.14998 4.6 5.86248 4.8 6.63748C5 7.41248 5.30833 8.29998 5.725 9.29998ZM14.95 18.375C15.6333 18.6916 16.375 18.95 17.175 19.15C17.975 19.35 18.75 19.4666 19.5 19.5V16.825L16.925 16.3L14.95 18.375Z" />
        </svg>
      );
    case 'decline':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          fill={fill}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M16.85 16.7425L18.29 15.3025L13.41 10.4225L10.12 13.7125C9.72998 14.1025 9.09998 14.1025 8.70998 13.7125L2.70998 7.70253C2.31998 7.31253 2.31998 6.68253 2.70998 6.29253C3.09998 5.90253 3.72998 5.90253 4.11998 6.29253L9.40998 11.5925L12.7 8.30253C13.09 7.91253 13.72 7.91253 14.11 8.30253L19.7 13.8825L21.14 12.4425C21.45 12.1325 21.99 12.3525 21.99 12.7925V17.0925C22 17.3725 21.78 17.5925 21.5 17.5925H17.21C16.76 17.5925 16.54 17.0525 16.85 16.7425Z" />
        </svg>
      );
    case 'usdc':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_1174_31794)">
            <path
              d="M12 24C18.65 24 24 18.65 24 12C24 5.34996 18.65 0 12 0C5.34996 0 0 5.34996 0 12C0 18.65 5.34996 24 12 24Z"
              fill="#2775CA"
            />
            <path
              d="M15.3015 13.8996C15.3015 12.1496 14.2515 11.5496 12.1515 11.2997C10.6515 11.0996 10.3515 10.6997 10.3515 9.99961C10.3515 9.29953 10.8516 8.84965 11.8515 8.84965C12.7515 8.84965 13.2516 9.14965 13.5015 9.89965C13.5516 10.0496 13.7016 10.1496 13.8516 10.1496H14.6515C14.8515 10.1496 15.0015 9.99961 15.0015 9.79969V9.74965C14.8015 8.64961 13.9015 7.79965 12.7515 7.69969V6.49969C12.7515 6.29965 12.6015 6.14965 12.3516 6.09961H11.6016C11.4015 6.09961 11.2515 6.24961 11.2015 6.49969V7.64965C9.70148 7.84969 8.75156 8.84965 8.75156 10.0997C8.75156 11.7497 9.75152 12.3996 11.8515 12.6497C13.2516 12.8997 13.7016 13.1997 13.7016 13.9997C13.7016 14.7997 13.0015 15.3497 12.0516 15.3497C10.7515 15.3497 10.3015 14.7996 10.1515 14.0496C10.1016 13.8497 9.95156 13.7496 9.80156 13.7496H8.95148C8.75156 13.7496 8.60156 13.8996 8.60156 14.0997V14.1497C8.80148 15.3996 9.60152 16.2996 11.2515 16.5497V17.7497C11.2515 17.9496 11.4015 18.0996 11.6515 18.1496H12.4015C12.6015 18.1496 12.7515 17.9997 12.8016 17.7497V16.5497C14.3016 16.2996 15.3015 15.2496 15.3015 13.8996Z"
              fill="white"
            />
            <path
              d="M9.45097 19.1499C5.55097 17.75 3.55094 13.4 5.00102 9.54992C5.75102 7.44992 7.40101 5.84996 9.45097 5.09996C9.65101 5 9.75098 4.85 9.75098 4.59992V3.89996C9.75098 3.69992 9.65101 3.54992 9.45097 3.5C9.40093 3.5 9.30098 3.5 9.25094 3.54992C4.50098 5.04992 1.90093 10.1 3.40093 14.85C4.30093 17.6499 6.45098 19.8 9.25094 20.7C9.45097 20.7999 9.65102 20.7 9.70093 20.4999C9.75098 20.45 9.75098 20.4 9.75098 20.3V19.5999C9.75098 19.4499 9.60098 19.25 9.45097 19.1499ZM14.751 3.54992C14.551 3.44996 14.3509 3.54992 14.301 3.74996C14.251 3.8 14.251 3.84992 14.251 3.95V4.64996C14.251 4.85 14.401 5.04992 14.551 5.15C18.451 6.54992 20.451 10.8999 19.0009 14.75C18.2509 16.85 16.6009 18.45 14.551 19.2C14.3509 19.2999 14.251 19.4499 14.251 19.7V20.4C14.251 20.6 14.3509 20.75 14.551 20.7999C14.601 20.7999 14.701 20.7999 14.751 20.75C19.501 19.25 22.101 14.1999 20.601 9.44996C19.701 6.59996 17.5009 4.44992 14.751 3.54992Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1174_31794">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'usdt':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_1174_31857)">
            <circle cx="12" cy="12" r="12" fill="#50AF95" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.526 12.9882C13.4408 12.9942 13.0004 13.0189 12.0181 13.0189C11.2368 13.0189 10.6821 12.9969 10.4875 12.9882C7.46818 12.8632 5.21452 12.3687 5.21452 11.7766C5.21452 11.1845 7.46818 10.6906 10.4875 10.5637V12.4957C10.685 12.509 11.2503 12.5404 12.0316 12.5404C12.9692 12.5404 13.4386 12.5037 13.5232 12.4963V10.565C16.5361 10.6913 18.7848 11.1858 18.7848 11.7766C18.7848 12.3673 16.5368 12.8619 13.5232 12.9875L13.526 12.9882ZM13.526 10.3652V8.63635H17.7307V6H6.28275V8.63635H10.4868V10.3645C7.06972 10.5122 4.5 11.1491 4.5 11.9123C4.5 12.6754 7.06972 13.3116 10.4868 13.46V19H13.5253V13.458C16.9345 13.3103 19.5 12.6741 19.5 11.9116C19.5 11.1491 16.9374 10.5135 13.526 10.3652Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1174_31857">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'dai':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_2196_80754)">
            <path
              d="M12 0C18.628 0 24 5.37305 24 12C24 18.628 18.628 24 12 24C5.37305 24 0 18.6275 0 12C0 5.37305 5.37305 0 12 0Z"
              fill="#F5AC37"
            />
            <path
              d="M12.4422 12.8474H17.002C17.0992 12.8474 17.1451 12.8474 17.1521 12.7199C17.1894 12.2561 17.1894 11.7895 17.1521 11.3251C17.1521 11.2349 17.1073 11.1977 17.0096 11.1977H7.93477C7.82245 11.1977 7.79221 11.2349 7.79221 11.3402V12.6751C7.79221 12.8474 7.79221 12.8474 7.97203 12.8474H12.4422ZM16.6429 9.63758C16.6559 9.60356 16.6559 9.56629 16.6429 9.53281C16.5668 9.36703 16.4766 9.20881 16.3718 9.06031C16.2141 8.80651 16.0284 8.57268 15.8167 8.36262C15.7168 8.23572 15.6012 8.12178 15.4716 8.02512C14.8225 7.47269 14.0509 7.08173 13.2214 6.88517C12.8029 6.79121 12.3752 6.74639 11.9465 6.75017H7.91911C7.80679 6.75017 7.79167 6.79499 7.79167 6.89273V9.55496C7.79167 9.66728 7.79167 9.69752 7.93423 9.69752H16.5889C16.5889 9.69752 16.664 9.6824 16.6791 9.63758H16.6424H16.6429ZM16.6429 14.4074C16.5155 14.3934 16.3869 14.3934 16.2595 14.4074H7.94233C7.83001 14.4074 7.79221 14.4074 7.79221 14.5576V17.1604C7.79221 17.2803 7.79221 17.3105 7.94233 17.3105H11.7823C11.9659 17.3246 12.1495 17.3116 12.3293 17.2733C12.8866 17.2333 13.4347 17.1123 13.9575 16.9131C14.1475 16.8472 14.3311 16.7613 14.5045 16.6582H14.5569C15.457 16.19 16.1882 15.4545 16.6494 14.5516C16.6494 14.5516 16.7018 14.4382 16.6429 14.4085V14.4074ZM6.28506 18.66V18.6152V16.8677V16.2753V14.5127C6.28506 14.415 6.28506 14.4004 6.16517 14.4004H4.5376C4.44742 14.4004 4.41016 14.4004 4.41016 14.2805V12.8555H6.15005C6.24725 12.8555 6.28506 12.8555 6.28506 12.728V11.3181C6.28506 11.2279 6.28506 11.2058 6.16517 11.2058H4.5376C4.44742 11.2058 4.41016 11.2058 4.41016 11.0859V9.7661C4.41016 9.68348 4.41016 9.66134 4.53004 9.66134H6.14249C6.25481 9.66134 6.28506 9.66134 6.28506 9.51877V5.47629C6.28506 5.35641 6.28506 5.32617 6.43518 5.32617H12.0599C12.4681 5.34237 12.8737 5.38719 13.2749 5.46117C14.1016 5.61399 14.896 5.90938 15.6223 6.33112C16.104 6.61462 16.5473 6.95699 16.9421 7.35119C17.2391 7.65954 17.5069 7.99326 17.7445 8.34858C17.9805 8.70877 18.1765 9.09379 18.3304 9.49609C18.3493 9.60086 18.4498 9.6716 18.5545 9.65378H19.897C20.0692 9.65378 20.0692 9.65378 20.0768 9.81902V11.0491C20.0768 11.169 20.032 11.1993 19.9116 11.1993H18.8764C18.7716 11.1993 18.7414 11.1993 18.7489 11.3343C18.79 11.7911 18.79 12.2496 18.7489 12.7064C18.7489 12.8339 18.7489 12.849 18.892 12.849H20.0763C20.1286 12.9165 20.0763 12.984 20.0763 13.052C20.0838 13.139 20.0838 13.227 20.0763 13.3139V14.2217C20.0763 14.3491 20.039 14.3869 19.9261 14.3869H18.5086C18.4098 14.368 18.3137 14.4312 18.291 14.5295C17.9535 15.407 17.4135 16.1938 16.7158 16.8245C16.4609 17.054 16.1931 17.27 15.9134 17.4693C15.6131 17.6421 15.321 17.8219 15.0132 17.9645C14.4467 18.2193 13.8527 18.4073 13.243 18.5266C12.6641 18.6303 12.0772 18.6773 11.488 18.6692H6.2829V18.6616L6.28506 18.66Z"
              fill="#FEFEFD"
            />
          </g>
          <defs>
            <clipPath id="clip0_2196_80754">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'renbtc':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.9473 13.273C19.9473 12.5799 19.7943 12.0387 19.4941 11.6494C19.1651 11.2182 18.6899 11.0089 18.0675 11.0138C17.5005 11.0138 17.0577 11.2026 16.7355 11.5978C16.3989 11.9852 16.2383 12.4621 16.2383 13.0354C16.2383 13.6759 16.4142 14.1753 16.7651 14.5403C17.0941 14.8897 17.5406 15.0688 18.1038 15.0688C18.5619 15.0835 19.0095 14.927 19.3621 14.6289C19.624 14.3902 19.8079 14.0757 19.889 13.7275H19.0561C18.981 13.9082 18.8658 14.0688 18.7196 14.1967C18.5367 14.323 18.3188 14.3858 18.0981 14.3758C17.8365 14.3911 17.5819 14.2873 17.4029 14.0925C17.2404 13.9066 17.1457 13.6302 17.1161 13.273H19.9473ZM17.1314 12.6344C17.1606 12.3766 17.2679 12.1344 17.4383 11.9414V11.9404C17.6138 11.7732 17.8496 11.6876 18.0895 11.7039C18.6746 11.7039 19.0045 12.0085 19.0772 12.6344H17.1314Z"
            fill="black"
          />
          <path
            d="M24.0013 12.5878V14.9628H23.1675V12.6618C23.1675 12.0281 22.8807 11.7157 22.307 11.7157C22.1046 11.7145 21.91 11.795 21.7658 11.9395C21.5817 12.128 21.4736 12.3797 21.4627 12.6452V14.9619H20.6289V11.1132H21.4627V11.5599C21.5978 11.3887 21.7673 11.249 21.9599 11.1501C22.1532 11.0537 22.3662 11.0053 22.5814 11.009C23.5232 11.008 24.0013 11.5298 24.0013 12.5878Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.4972 12.7545L15.9936 14.964H14.9007L13.4397 12.7963H12.5246V14.963H11.6641V9.64551H13.9962C14.5307 9.64551 14.9552 9.76523 15.2621 10.0105C15.5844 10.2792 15.7527 10.6666 15.7527 11.1727V11.2214V11.2701C15.7527 11.7772 15.5844 12.1646 15.2621 12.4323C15.0376 12.6029 14.7746 12.7137 14.4972 12.7545ZM13.8786 10.3901H12.5246V12.0507H13.8786C14.2123 12.0507 14.4676 11.9758 14.6435 11.8346C14.8073 11.675 14.8952 11.451 14.8845 11.2204C14.8952 10.9899 14.8073 10.7659 14.6435 10.6062C14.4714 10.4651 14.2151 10.3901 13.8786 10.3901Z"
            fill="black"
          />
          <path
            d="M1.39889 9.19009L2.15139 8.75013L2.25275 8.92728L5.0266 7.29883L4.82391 7.18007L4.62023 7.05938L4.51889 7L0 9.65731V9.77606L1.29753 9.01196L1.39889 9.19009Z"
            fill="black"
          />
          <path
            d="M1.39889 10.8631L3.57323 9.58412L3.67457 9.76419L6.44846 8.13477L6.24574 8.01407L6.04209 7.89532L5.94071 7.83691L0 11.3284V11.4471L1.29753 10.6831L1.39889 10.8631Z"
            fill="black"
          />
          <path
            d="M1.39889 11.6997L4.28366 10.004L4.38597 10.1822L7.15889 8.55079L6.95617 8.43398L6.75346 8.31328L6.65114 8.25391L0 12.163V12.2837L1.29753 11.5205L1.39889 11.6997Z"
            fill="black"
          />
          <path
            d="M1.39889 12.5352L5.01514 10.4103L5.11746 10.5884L7.87029 8.9707L7.66757 8.85L7.46391 8.73125L7.36254 8.67188L0 13.0005V13.1192L1.29753 12.3551L1.39889 12.5352Z"
            fill="black"
          />
          <path
            d="M1.39889 13.3688L5.72654 10.8263L5.82789 11.0064L8.58071 9.38672L8.378 9.26894L8.17529 9.14824L8.073 9.08887L0 13.8341V13.9528L1.29753 13.1907L1.39889 13.3688Z"
            fill="black"
          />
          <path
            d="M8.88574 9.56621L8.78437 9.50586L0 14.6706V14.7893L1.29753 14.0272L1.39889 14.2053L5.72654 11.6628L5.82789 11.841L9.03777 9.95556V9.71611V9.65673L8.88574 9.56621Z"
            fill="black"
          />
          <path
            d="M0.556474 15.2968L1.28412 14.8694L1.38548 15.0476L5.70549 12.509L5.80683 12.6891L9.03774 10.79V10.5506V10.3111V10.1924L0.457031 15.2374L0.556474 15.2968Z"
            fill="black"
          />
          <path
            d="M5.70599 13.3459L5.80733 13.526L9.03824 11.627V11.3875V11.148V11.0293L1.16797 15.6548L1.27028 15.7142L2.00845 15.279L2.11076 15.4591"
            fill="black"
          />
          <path
            d="M1.97827 16.1335L2.71739 15.6974L2.81874 15.8775L5.70353 14.1809L5.80487 14.361L9.03579 12.4619V12.2225V11.985V11.8652L1.875 16.0722L1.97827 16.1335Z"
            fill="black"
          />
          <path
            d="M2.6912 16.5509L3.43033 16.1167L3.53264 16.2949L5.70602 15.0178L5.80739 15.1959L9.0383 13.2969V13.0594V12.8199V12.7012L2.58984 16.4915L2.6912 16.5509Z"
            fill="black"
          />
          <path
            d="M3.30078 16.9089L3.40215 16.9683L4.14318 16.5332L4.24261 16.7132L5.70558 15.8518L5.80692 16.0319L9.03784 14.1328V13.8934V13.6539V13.5352L3.30078 16.9089Z"
            fill="black"
          />
          <path
            d="M4.11306 17.3876L4.85218 16.9506L4.95355 17.1306L5.70606 16.6868L5.8074 16.8668L9.03832 14.9697V14.7303V14.4908V14.3721L4.01172 17.3282L4.11306 17.3876Z"
            fill="black"
          />
          <path
            d="M5.738 7.71679L5.53434 7.59804L5.33163 7.47929L5.23029 7.41797L0 10.4919V10.6106L1.29753 9.84945L1.39889 10.0266L2.86183 9.16712L2.96606 9.34719L5.738 7.71679Z"
            fill="black"
          />
        </svg>
      );
    case 'wbtc':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_2196_80773)">
            <path
              d="M19.5691 5.03686L18.9102 5.69584C20.4826 7.4154 21.3546 9.66117 21.3546 11.9913C21.3546 14.3214 20.4826 16.5672 18.9102 18.2867L19.5691 18.9457C21.3178 17.0489 22.2887 14.5635 22.2887 11.9836C22.2887 9.4037 21.3178 6.91829 19.5691 5.02148V5.03686Z"
              fill="#5A5564"
            />
            <path
              d="M5.70951 5.09438C7.42908 3.52194 9.67484 2.64995 12.005 2.64995C14.3351 2.64995 16.5808 3.52194 18.3004 5.09438L18.9594 4.4354C17.0626 2.68669 14.5772 1.71582 11.9973 1.71582C9.41737 1.71582 6.93196 2.68669 5.03516 4.4354L5.70951 5.09438Z"
              fill="#5A5564"
            />
            <path
              d="M5.0934 18.2931C3.52283 16.5739 2.65198 14.3295 2.65198 12.0009C2.65198 9.67235 3.52283 7.42796 5.0934 5.70878L4.43442 5.0498C2.68571 6.94661 1.71484 9.43202 1.71484 12.0119C1.71484 14.5918 2.68571 17.0772 4.43442 18.974L5.0934 18.2931Z"
              fill="#5A5564"
            />
            <path
              d="M18.2928 18.9014C16.5733 20.4738 14.3275 21.3458 11.9974 21.3458C9.66727 21.3458 7.42151 20.4738 5.70195 18.9014L5.04297 19.5603C6.93977 21.3091 9.42519 22.2799 12.0051 22.2799C14.585 22.2799 17.0704 21.3091 18.9672 19.5603L18.2928 18.9014Z"
              fill="#5A5564"
            />
            <path
              d="M16.1586 9.80106C16.0268 8.426 14.8406 7.96471 13.3403 7.82413V5.93066H12.1805V7.78898C11.8752 7.78898 11.5633 7.78898 11.2536 7.78898V5.93066H10.1026V7.83731H7.75V9.07839C7.75 9.07839 8.60667 9.06301 8.59349 9.07839C8.74796 9.06139 8.90299 9.10503 9.02591 9.20009C9.14884 9.29515 9.23007 9.43422 9.25247 9.588V14.8071C9.24917 14.8613 9.23503 14.9144 9.21088 14.963C9.18674 15.0117 9.15307 15.055 9.11189 15.0905C9.07148 15.1266 9.02418 15.1541 8.97284 15.1715C8.92151 15.1889 8.86719 15.1957 8.81315 15.1915C8.82853 15.2047 7.96966 15.1915 7.96966 15.1915L7.75 16.5776H10.0806V18.515H11.2404V16.6061H12.1674V18.5062H13.3294V16.5907C15.2887 16.4721 16.655 15.9889 16.8263 14.1547C16.9647 12.6786 16.2706 12.0196 15.1613 11.7538C15.8357 11.4222 16.253 10.8071 16.1586 9.80106ZM14.5331 13.9263C14.5331 15.3672 12.0641 15.2025 11.2777 15.2025V12.6457C12.0641 12.6479 14.5331 12.4216 14.5331 13.9263ZM13.9949 10.3239C13.9949 11.6418 11.9345 11.4815 11.2799 11.4815V9.15746C11.9345 9.15746 13.9949 8.95098 13.9949 10.3239Z"
              fill="#F09242"
            />
            <path
              d="M11.9978 24C9.62462 23.9996 7.30485 23.2955 5.33179 21.9767C3.35874 20.658 1.82101 18.7838 0.913031 16.5912C0.00505138 14.3986 -0.232403 11.986 0.230689 9.65838C0.693782 7.33082 1.83663 5.19282 3.51472 3.51472C5.19282 1.83663 7.33082 0.693782 9.65838 0.230689C11.986 -0.232403 14.3986 0.00505138 16.5912 0.913031C18.7838 1.82101 20.658 3.35874 21.9767 5.33179C23.2955 7.30485 23.9996 9.62462 24 11.9978C24.0003 13.574 23.69 15.1349 23.087 16.5912C22.4839 18.0475 21.5999 19.3707 20.4853 20.4853C19.3707 21.5999 18.0475 22.4839 16.5912 23.087C15.1349 23.69 13.574 24.0003 11.9978 24ZM11.9978 0.935755C9.81137 0.937492 7.67453 1.58738 5.85735 2.80327C4.04018 4.01916 2.62426 5.74648 1.78855 7.7669C0.952839 9.78732 0.734858 12.0101 1.16216 14.1544C1.58945 16.2987 2.64285 18.2682 4.1892 19.8139C5.73555 21.3596 7.70544 22.4123 9.84989 22.8387C11.9943 23.2652 14.2171 23.0463 16.2372 22.2098C18.2572 21.3733 19.984 19.9567 21.1992 18.139C22.4143 16.3214 23.0634 14.1842 23.0643 11.9978C23.0648 10.5446 22.779 9.1055 22.223 7.76285C21.667 6.42019 20.8518 5.20029 19.824 4.17291C18.7962 3.14553 17.576 2.33082 16.2331 1.77537C14.8902 1.21991 13.451 0.9346 11.9978 0.935755Z"
              fill="#282138"
            />
          </g>
          <defs>
            <clipPath id="clip0_2196_80773">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'busd':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_2196_80782)">
            <path
              d="M12.0021 0.0507812L14.9627 3.07372L7.50755 10.5066L4.54688 7.55478L12.0021 0.0507812Z"
              fill="#F0B90B"
              stroke="#F0B90B"
            />
            <path
              d="M16.4966 4.53223L19.4573 7.55517L7.50755 19.4691L4.54688 16.5173L16.4966 4.53223Z"
              fill="#F0B90B"
              stroke="#F0B90B"
            />
            <path
              d="M3.01145 9.0127L5.97213 12.0356L3.01145 14.9874L0.0507812 12.0356L3.01145 9.0127Z"
              fill="#F0B90B"
              stroke="#F0B90B"
            />
            <path
              d="M20.9888 9.0127L23.9494 12.0356L11.9997 23.9496L9.03906 20.9978L20.9888 9.0127Z"
              fill="#F0B90B"
              stroke="#F0B90B"
            />
          </g>
          <defs>
            <clipPath id="clip0_2196_80782">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'gusd':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_2196_80791)">
            <path
              d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
              fill="#00DCFA"
            />
            <path
              d="M14.5335 3.75C11.631 3.75 9.16575 5.982 8.856 8.85525C5.98125 9.16575 3.75 11.631 3.75 14.5328C3.75079 16.0487 4.3533 17.5023 5.42516 18.5743C6.49701 19.6463 7.95056 20.249 9.4665 20.25C12.369 20.25 14.844 18.018 15.144 15.1448C18.018 14.8343 20.25 12.369 20.25 9.46725C20.2492 7.95131 19.6467 6.49768 18.5748 5.42569C17.503 4.35369 16.0494 3.75099 14.5335 3.75ZM18.9105 10.107C18.7678 11.0445 18.3291 11.9119 17.6585 12.5825C16.9879 13.2531 16.1205 13.6918 15.183 13.8345V10.107H18.9105ZM5.0895 13.893C5.23031 12.9537 5.66815 12.0841 6.33889 11.4116C7.00963 10.7391 7.87805 10.299 8.817 10.1558V13.8832H5.0895V13.893ZM13.8442 15.183C13.6894 16.2331 13.1619 17.1925 12.3581 17.8858C11.5544 18.5791 10.528 18.9602 9.4665 18.9592C8.40521 18.9602 7.37902 18.5792 6.5754 17.886C5.77177 17.1929 5.24435 16.2337 5.0895 15.1838H13.8442V15.183ZM13.893 10.107V13.8832H10.107V10.107H13.893ZM18.9105 8.817H10.1558C10.3106 7.76687 10.8381 6.80751 11.6419 6.11418C12.4456 5.42085 13.472 5.03984 14.5335 5.04075C15.5948 5.03984 16.621 5.42077 17.4246 6.11396C18.2282 6.80715 18.7556 7.76632 18.9105 8.81625V8.817Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_2196_80791">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case 'giftcard':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 -960 960 960"
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
        >
          <path d="M140-277v97h680v-97H140Zm0-443h125q-5-9-8-22.5t-3-24.5q0-47.083 33-80.042Q320-880 366-880q30.741 0 56.87 15.5Q449-849 464-825l16.5 26 16.5-26q16-25 41.015-40t53.879-15Q640-880 673-847.5q33 32.5 33 80.861Q706-756 703.5-745t-7.5 25h124q24 0 42 18t18 42v480q0 24-18 42t-42 18H140q-24 0-42-18t-18-42v-480q0-24 18-42t42-18Zm0 336h680v-276H571l100 139-48 36-143-198-143 198-48-36 100-139H140v276Zm227-330q22 0 37.5-15.5T420-767q0-22-15.5-37.5T367-820q-22 0-37.5 15.5T314-767q0 22 15.5 37.5T367-714Zm225 0q22.95 0 38.475-15.5Q646-745 646-767t-15.525-37.5Q614.95-820 592-820q-21 0-36.5 15.5T540-767q0 22 15.5 37.5T592-714Z" />
        </svg>
      );

    case 'verification':
      return (
        <svg
          style={{ minWidth: size }}
          className={className}
          ref={ref}
          width={size}
          height={size}
          viewBox="0 0 64 64"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M59.5863 50.7581H4.41375C1.97613 50.7581 0 48.782 0 46.3444V13.2409C0 10.8033 1.97613 8.82715 4.41375 8.82715H59.5863C62.0239 8.82715 64 10.8033 64 13.2409V46.3444C64 48.782 62.0239 50.7581 59.5863 50.7581Z"
            fill="#1743EA"
          />
          <path
            d="M18.7591 37.5176C13.2743 37.5176 8.82812 41.9638 8.82812 47.4486C8.82812 48.6112 9.03825 49.7221 9.40537 50.7589H28.113C28.48 49.7221 28.6903 48.6112 28.6903 47.4486C28.6901 41.9638 24.244 37.5176 18.7591 37.5176Z"
            fill="#1743EA"
          />
          <path
            d="M32.0003 46.3447H5.51756C4.90819 46.3447 4.41406 45.8506 4.41406 45.2412V14.3447C4.41406 13.7353 4.90819 13.2412 5.51756 13.2412H32.0003C32.6097 13.2412 33.1038 13.7353 33.1038 14.3447V45.2412C33.1038 45.8506 32.6097 46.3447 32.0003 46.3447Z"
            fill="#1743EA"
          />
          <path
            d="M8.89258 46.3452H28.6253C28.076 41.3802 23.8705 37.5176 18.759 37.5176C13.6475 37.5176 9.44208 41.3802 8.89258 46.3452Z"
            fill="#1743EA"
          />
          <path
            d="M27.587 41.9313C28.1964 41.9313 28.6905 41.4372 28.6905 40.8278V38.0047C28.6905 37.0548 28.0826 36.2114 27.1815 35.9111L22.8226 34.458C22.3729 34.3082 22.0691 33.8877 22.0681 33.4137L22.064 31.4514C22.7529 31.107 23.2124 30.4284 23.2762 29.6608L23.5174 27.0332C23.979 26.6288 24.2766 26.0415 24.2766 25.3795V19.8623C24.2766 19.2529 23.7825 18.7588 23.1731 18.7588H16.5524C14.7241 18.7588 13.242 20.2409 13.242 22.0692V25.3795C13.242 26.0417 13.5396 26.6288 14.0012 27.0332L14.2424 29.6608C14.3062 30.4283 14.7659 31.107 15.4546 31.4514L15.4505 33.4137C15.4495 33.8878 15.1457 34.3083 14.696 34.458L10.3371 35.9111C9.436 36.2114 8.82812 37.0548 8.82812 38.0047V40.8278C8.82812 41.4372 9.32225 41.9313 9.93162 41.9313H27.587Z"
            fill="white"
          />
          <path
            d="M52.9658 16.5517H37.5176C36.9077 16.5517 36.4141 16.0576 36.4141 15.4482C36.4141 14.8389 36.9076 14.3447 37.5176 14.3447H52.9658C53.5757 14.3447 54.0693 14.8389 54.0693 15.4482C54.0693 16.0576 53.5758 16.5517 52.9658 16.5517Z"
            fill="#C5CEE4"
          />
          <path
            d="M58.4831 20.9658H37.5176C36.9077 20.9658 36.4141 20.4717 36.4141 19.8623C36.4141 19.2529 36.9076 18.7588 37.5176 18.7588H58.4831C59.0929 18.7588 59.5866 19.2529 59.5866 19.8623C59.5866 20.4718 59.0931 20.9658 58.4831 20.9658Z"
            fill="#F6F6F6"
          />
          <path
            d="M58.4835 36.414H44.1387C43.5288 36.414 43.0352 35.9199 43.0352 35.3105C43.0352 34.7012 43.5287 34.207 44.1387 34.207H58.4835C59.0934 34.207 59.587 34.7012 59.587 35.3105C59.587 35.9199 59.0935 36.414 58.4835 36.414Z"
            fill="#C5CEE4"
          />
          <path
            d="M39.7244 36.414H37.5176C36.9077 36.414 36.4141 35.9199 36.4141 35.3105C36.4141 34.7012 36.9076 34.207 37.5176 34.207H39.7244C40.3343 34.207 40.8279 34.7012 40.8279 35.3105C40.8279 35.9199 40.3344 36.414 39.7244 36.414Z"
            fill="#F6F6F6"
          />
          <path
            d="M55.1732 40.8281H44.1387C43.5288 40.8281 43.0352 40.334 43.0352 39.7246C43.0352 39.1152 43.5287 38.6211 44.1387 38.6211H55.1732C55.783 38.6211 56.2767 39.1152 56.2767 39.7246C56.2767 40.334 55.7832 40.8281 55.1732 40.8281Z"
            fill="#C5CEE4"
          />
          <path
            d="M39.7244 40.8281H37.5176C36.9077 40.8281 36.4141 40.334 36.4141 39.7246C36.4141 39.1152 36.9076 38.6211 37.5176 38.6211H39.7244C40.3343 38.6211 40.8279 39.1152 40.8279 39.7246C40.8279 40.334 40.3344 40.8281 39.7244 40.8281Z"
            fill="#F6F6F6"
          />
          <path
            d="M55.1732 45.2412H44.1387C43.5288 45.2412 43.0352 44.7471 43.0352 44.1377C43.0352 43.5283 43.5287 43.0342 44.1387 43.0342H55.1732C55.783 43.0342 56.2767 43.5283 56.2767 44.1377C56.2767 44.7471 55.7832 45.2412 55.1732 45.2412Z"
            fill="#C5CEE4"
          />
          <path
            d="M39.7244 45.2412H37.5176C36.9077 45.2412 36.4141 44.7471 36.4141 44.1377C36.4141 43.5283 36.9076 43.0342 37.5176 43.0342H39.7244C40.3343 43.0342 40.8279 43.5283 40.8279 44.1377C40.8279 44.7471 40.3344 45.2412 39.7244 45.2412Z"
            fill="#F6F6F6"
          />
          <path
            d="M39.7235 30.3444C41.247 30.3444 42.4821 29.1093 42.4821 27.5858C42.4821 26.0622 41.247 24.8271 39.7235 24.8271C38.1999 24.8271 36.9648 26.0622 36.9648 27.5858C36.9648 29.1093 38.1999 30.3444 39.7235 30.3444Z"
            fill="white"
          />
          <path
            d="M48.5516 30.3444C50.0751 30.3444 51.3102 29.1093 51.3102 27.5858C51.3102 26.0622 50.0751 24.8271 48.5516 24.8271C47.028 24.8271 45.793 26.0622 45.793 27.5858C45.793 29.1093 47.028 30.3444 48.5516 30.3444Z"
            fill="white"
          />
          <path
            d="M57.3797 30.3444C58.9033 30.3444 60.1384 29.1093 60.1384 27.5858C60.1384 26.0622 58.9033 24.8271 57.3797 24.8271C55.8562 24.8271 54.6211 26.0622 54.6211 27.5858C54.6211 29.1093 55.8562 30.3444 57.3797 30.3444Z"
            fill="white"
          />
          <path
            d="M27.0147 41.9313C25.2331 39.2703 22.2011 37.5176 18.7583 37.5176C15.3156 37.5176 12.2836 39.2705 10.502 41.9313H27.0147Z"
            fill="white"
          />
          <path
            d="M18.7593 55.1719C23.0252 55.1719 26.4834 51.7137 26.4834 47.4478C26.4834 43.1818 23.0252 39.7236 18.7593 39.7236C14.4934 39.7236 11.0352 43.1818 11.0352 47.4478C11.0352 51.7137 14.4934 55.1719 18.7593 55.1719Z"
            fill="#1743EA"
          />
          <path
            d="M18.0236 50.7584C17.7681 50.7584 17.5129 50.6705 17.306 50.4928L14.7316 48.2859C14.2684 47.8894 14.2144 47.1927 14.612 46.7299C15.0085 46.2675 15.7057 46.2143 16.1669 46.6103L17.9309 48.1227L21.2563 44.4955C21.6679 44.0457 22.3651 44.0165 22.8155 44.4277C23.2649 44.8398 23.2951 45.5375 22.8834 45.9869L18.837 50.4007C18.6195 50.6377 18.3221 50.7584 18.0236 50.7584Z"
            fill="white"
          />
        </svg>
      );

    default:
      return null;
  }
});

Icon.displayName = 'Icon';

export default Icon;
